<template>
  <div class="row" id="ficha-atividade-coletiva">
    <!-- Loading durante carregamento da edição -->
    <div
      v-if="carregandoEdicao"
      class="col-md-12 d-flex justify-content-center align-items-center"
      style="min-height: 400px"
    >
      <div class="text-center">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem"
        ></b-spinner>
        <p class="mt-3">Carregando dados da atividade...</p>
      </div>
    </div>

    <div v-else class="col-md-12">
      <!-- Seção 1: Informações da Atividade em Saúde + Profissionais envolvidos -->
      <TabCabecalho
        ref="cabecalho"
        :formData="formData.fichaAtividadeColetivaTransport"
        :participantes="formData.fichaAtividadeColetivaTransport.participantes"
        :profissionais="formData.fichaAtividadeColetivaTransport.profissionais"
        :getCboId="getCboId"
        :isEditMode="!!$route.query.id"
        :erroResponsavel="erroResponsavel"
        :cpfUsuarioLogado="cpf"
        @tipo-mudou="onTipoMudou"
        @update:profissionais="atualizarProfissionais"
      />

      <!-- Seção 3: Dados da Atividade -->
      <div class="mt-4">
        <div class="card card-topo">
          <div class="card-header bg-light font-weight-bold">
            Dados da atividade
          </div>
          <div class="card-body">
            <div class="row">
              <!-- Tipo da atividade -->
              <div class="col-md-4 mb-3">
                <label class="form-label required">Tipo da atividade *</label>
                <vue-select
                  v-model="
                    formData.fichaAtividadeColetivaTransport.atividadeTipo
                  "
                  :options="opcoesTipoAtividade"
                  label="descricao"
                  placeholder="Selecione o tipo"
                  :clearable="false"
                  @input="validarTipo"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.descricao }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <div v-if="erros.tipoAtividade" class="text-danger mt-1 small">
                  {{ erros.tipoAtividade }}
                </div>
              </div>

              <!-- Tema da reunião (agora é array) -->
              <div class="col-md-4 mb-3">
                <label
                  class="form-label"
                  :class="{ required: isTemaReuniaoObrigatorio }"
                >
                  Tema da reunião <span v-if="isTemaReuniaoObrigatorio">*</span>
                </label>
                <vue-select
                  v-model="
                    formData.fichaAtividadeColetivaTransport.temasParaReuniao
                  "
                  :options="opcoesTemasReuniao"
                  label="descricao"
                  :value="
                    formData.fichaAtividadeColetivaTransport.temasParaReuniao
                  "
                  placeholder="Selecione o(s) tema(s)"
                  multiple
                  :clearable="true"
                  @input="validarTemaReuniao"
                >
                  <template slot="option" slot-scope="option">
                    <div class="d-flex align-items-center">
                      <i
                        class="mdi mr-2"
                        :class="
                          isTemaReuniaoSelecionado(option)
                            ? 'mdi-checkbox-marked text-primary'
                            : 'mdi-checkbox-blank-outline'
                        "
                        style="font-size: 1.2rem"
                      ></i>
                      <span>{{ option.descricao }}</span>
                    </div>
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <div v-if="erros.temaReuniao" class="text-danger mt-1 small">
                  {{ erros.temaReuniao }}
                </div>
                <small
                  class="text-muted"
                  v-if="
                    formData.fichaAtividadeColetivaTransport.temasParaReuniao
                      .length > 0
                  "
                >
                  {{
                    formData.fichaAtividadeColetivaTransport.temasParaReuniao
                      .length
                  }}
                  tema(s) selecionado(s)
                </small>
              </div>

              <!-- Temas para a saúde (agora é array)
                   Só aparece para tipos ligados à saúde (atividadeTipo = 4, 5 ou 7)
                   ou quando já há algum valor selecionado -->
              <div
                class="col-md-4 mb-3"
                v-if="
                  isTemasParaSaudeObrigatorio ||
                  formData.fichaAtividadeColetivaTransport.temasParaSaude
                    .length > 0
                "
              >
                <label
                  class="form-label"
                  :class="{ required: isTemasParaSaudeObrigatorio }"
                >
                  Temas para a saúde
                  <span v-if="isTemasParaSaudeObrigatorio">*</span>
                </label>
                <vue-select
                  v-model="
                    formData.fichaAtividadeColetivaTransport.temasParaSaude
                  "
                  :options="opcoesTemasParaSaude"
                  label="descricao"
                  :value="
                    formData.fichaAtividadeColetivaTransport.temasParaSaude
                  "
                  placeholder="Selecione o(s) tema(s)"
                  multiple
                  :clearable="true"
                  @input="validarTemasParaSaude"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.descricao }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <div v-if="erros.temasParaSaude" class="text-danger mt-1 small">
                  {{ erros.temasParaSaude }}
                </div>
                <small
                  class="text-muted"
                  v-if="
                    formData.fichaAtividadeColetivaTransport.temasParaSaude
                      .length > 0
                  "
                >
                  {{
                    formData.fichaAtividadeColetivaTransport.temasParaSaude
                      .length
                  }}
                  tema(s) selecionado(s)
                </small>
              </div>
            </div>

            <!-- Público-Alvo (condicional: atividadeTipo = 4, 5, 6 ou 7) -->
            <div
              class="row mt-3"
              v-if="
                isPublicoAlvoObrigatorio ||
                formData.fichaAtividadeColetivaTransport.publicoAlvo.length > 0
              "
            >
              <div class="col-md-12">
                <label
                  class="form-label"
                  :class="{ required: isPublicoAlvoObrigatorio }"
                >
                  Público-Alvo <span v-if="isPublicoAlvoObrigatorio">*</span>
                </label>
                <vue-select
                  v-model="formData.fichaAtividadeColetivaTransport.publicoAlvo"
                  :options="opcoesPublicoAlvo"
                  label="descricao"
                  :value="formData.fichaAtividadeColetivaTransport.publicoAlvo"
                  placeholder="Selecione o(s) público(s)-alvo"
                  multiple
                  :clearable="true"
                  @input="validarPublicoAlvo"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.descricao }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <div v-if="erros.publicoAlvo" class="text-danger mt-1 small">
                  {{ erros.publicoAlvo }}
                </div>
                <small
                  class="text-muted"
                  v-if="
                    formData.fichaAtividadeColetivaTransport.publicoAlvo
                      .length > 0
                  "
                >
                  {{
                    formData.fichaAtividadeColetivaTransport.publicoAlvo.length
                  }}
                  público(s)-alvo selecionado(s)
                </small>
              </div>
            </div>

            <!-- Práticas em Saúde (condicional: atividadeTipo = 6) -->
            <div
              class="row mt-3"
              v-if="
                isPraticasEmSaudeObrigatorio ||
                formData.fichaAtividadeColetivaTransport.praticasEmSaude
                  .length > 0
              "
            >
              <div class="col-md-12">
                <label
                  class="form-label"
                  :class="{ required: isPraticasEmSaudeObrigatorio }"
                >
                  Práticas em Saúde
                  <span v-if="isPraticasEmSaudeObrigatorio">*</span>
                </label>
                <vue-select
                  v-model="
                    formData.fichaAtividadeColetivaTransport.praticasEmSaude
                  "
                  :options="opcoesPraticasEmSaude"
                  label="descricao"
                  :value="
                    formData.fichaAtividadeColetivaTransport.praticasEmSaude
                  "
                  placeholder="Selecione a(s) prática(s) em saúde"
                  multiple
                  :clearable="true"
                  @input="validarPraticasEmSaude"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.descricao }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
                <div
                  v-if="erros.praticasEmSaude"
                  class="text-danger mt-1 small"
                >
                  {{ erros.praticasEmSaude }}
                </div>
                <small
                  class="text-muted"
                  v-if="
                    formData.fichaAtividadeColetivaTransport.praticasEmSaude
                      .length > 0
                  "
                >
                  {{
                    formData.fichaAtividadeColetivaTransport.praticasEmSaude
                      .length
                  }}
                  prática(s) selecionada(s)
                </small>
              </div>
            </div>

            <!-- Procedimento (condicional: se praticasEmSaude contém valor 30) -->
            <div class="row mt-3" v-if="mostrarProcedimento">
              <div class="col-md-12">
                <label class="form-label">Procedimento (SIGTAP)</label>
                <vue-select
                  v-model="
                    formData.fichaAtividadeColetivaTransport.procedimento
                  "
                  :options="opcoesProcedimentos"
                  label="descricao"
                  placeholder="Selecione o procedimento"
                  :clearable="true"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.codigo }} - {{ option.descricao }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
            </div>

            <!-- Anotações da atividade -->
            <div class="row mt-3">
              <div class="col-md-12">
                <label class="form-label">Anotações da atividade</label>
                <textarea
                  class="form-control"
                  rows="5"
                  placeholder="Insira as anotações da atividade"
                  maxlength="4000"
                  v-model="formData.fichaAtividadeColetivaTransport.anotacoes"
                ></textarea>
                <small class="text-muted"
                  >{{ caracteresRestantesAnotacoes }}/4000 caracteres</small
                >
              </div>
            </div>

            <!-- Participantes (oculto por enquanto) -->
            <div class="row mt-4" v-if="false">
              <div class="col-md-12">
                <div class="participantes-section">
                  <div class="mb-3">
                    <h6 class="font-weight-bold mb-2">
                      Participantes
                      <span
                        v-if="isParticipantesObrigatorio"
                        class="text-danger"
                        >*</span
                      >
                    </h6>
                    <p class="small text-muted mb-0">
                      Cidadãos que participaram da atividade. Obrigatório para
                      "Atendimento em Grupo" e "Avaliação / Procedimento
                      coletivo".
                    </p>
                  </div>

                  <!-- Botão para adicionar participante -->
                  <div class="d-flex justify-content-end mb-2">
                    <button
                      class="btn btn-primary"
                      @click="abrirModalParticipante"
                    >
                      <i class="mdi mdi-plus mr-1"></i>
                      Adicionar participante
                    </button>
                  </div>

                  <!-- Tabela de participantes -->
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>CPF/CNS</th>
                          <th>Data Nascimento</th>
                          <th>Sexo</th>
                          <th>Peso (kg)</th>
                          <th>Altura (cm)</th>
                          <th>Avaliação Alterada</th>
                          <th class="text-center" style="width: 100px">
                            Ações
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="
                            formData.fichaAtividadeColetivaTransport
                              .participantes.length === 0
                          "
                        >
                          <td colspan="8" class="text-center text-muted">
                            Nenhum participante adicionado
                          </td>
                        </tr>
                        <tr
                          v-for="(participante, index) in formData
                            .fichaAtividadeColetivaTransport.participantes"
                          :key="index"
                        >
                          <td>{{ participante.nome || '-' }}</td>
                          <td>
                            {{
                              participante.cpfParticipante ||
                              participante.cnsParticipante ||
                              '-'
                            }}
                          </td>
                          <td>
                            {{
                              formatarDataParticipante(
                                participante.dataNascimento
                              )
                            }}
                          </td>
                          <td>
                            {{
                              participante.sexo === 0
                                ? 'Masculino'
                                : participante.sexo === 1
                                ? 'Feminino'
                                : '-'
                            }}
                          </td>
                          <td>{{ participante.peso || '-' }}</td>
                          <td>{{ participante.altura || '-' }}</td>
                          <td class="text-center">
                            <i
                              v-if="participante.avaliacaoAlterada"
                              class="mdi mdi-check text-success"
                            ></i>
                            <span v-else>-</span>
                          </td>
                          <td class="text-center">
                            <button
                              class="btn btn-link btn-sm text-danger p-0"
                              @click="removerParticipante(index)"
                              title="Remover"
                            >
                              <i class="mdi mdi-close"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="text-muted small mt-2">
                      {{
                        formData.fichaAtividadeColetivaTransport.participantes
                          .length
                      }}
                      participante(s) adicionado(s)
                    </div>
                  </div>
                  <div
                    v-if="erros.participantes"
                    class="text-danger mt-2 small"
                  >
                    {{ erros.participantes }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botões de Ação -->
      <div class="mt-4 d-flex justify-content-end gap-2">
        <button class="btn btn-secondary" @click="cancelar">Cancelar</button>
        <button class="btn btn-primary" @click="salvar" :disabled="enviando">
          <span v-if="enviando" class="d-flex align-items-center">
            <b-spinner small class="mr-2"></b-spinner>
            Enviando...
          </span>
          <span v-else> Salvar </span>
        </button>
      </div>

      <!-- Modal para Adicionar Participante -->
      <b-modal
        id="modal-participante"
        ref="modalParticipante"
        title="Adicionar Participante"
        size="lg"
        centered
        @hidden="resetarModalParticipante"
      >
        <form>
          <div class="form-group">
            <label for="participante-cidadao" class="form-label required"
              >Cidadão *</label
            >
            <vue-select
              id="participante-cidadao"
              v-model="novoParticipante.cidadao"
              :options="cidadaosDisponiveis"
              label="label"
              placeholder="Pesquise por nome, CPF, CNS ou data de nascimento"
              :loading="isLoadingCidadaos"
              @open="carregarCidadaos"
              :filterable="true"
              :searchable="true"
              :filter="filtrarCidadaos"
            >
              <template slot="option" slot-scope="option">
                <div>
                  <strong>{{ option.nome }}</strong>
                  <div class="small-text" v-if="option.cpf">
                    CPF: {{ option.cpf }}
                  </div>
                  <div class="small-text" v-if="option.cns">
                    CNS: {{ option.cns }}
                  </div>
                  <div class="small-text" v-if="option.dataNascimento">
                    Nascimento: {{ option.dataNascimento }}
                  </div>
                </div>
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input
                type="checkbox"
                id="participante-avaliacao-alterada"
                class="form-check-input"
                v-model="novoParticipante.avaliacaoAlterada"
              />
              <label
                for="participante-avaliacao-alterada"
                class="form-check-label"
              >
                Avaliação alterada (exames/avaliações com resultado alterado)
              </label>
            </div>
          </div>
        </form>
        <template #modal-footer>
          <button class="btn btn-secondary" @click="fecharModalParticipante">
            Cancelar
          </button>
          <button
            class="btn btn-primary"
            @click="adicionarParticipante"
            :disabled="!novoParticipante.cidadao || isLoadingCidadaos"
          >
            Adicionar
          </button>
        </template>
      </b-modal>

      <!-- Modal para Inserir Observações sobre Cidadão -->
    </div>
  </div>
</template>

<script>
import TabCabecalho from './tabs/TabCabecalho.vue'
import TabProfissionais from './tabs/TabProfissionais.vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { v4 as uuidv4 } from 'uuid'
import { jwtDecode } from 'jwt-decode'

export default {
  components: {
    TabCabecalho,
    TabProfissionais,
    'vue-select': VueSelect,
  },
  data() {
    return {
      inconsistencias: [],
      enviando: false,
      envioSucesso: false,
      jsonFinalEnviado: null,
      cpf: null,
      cpf: null,
      opcoesTipoAtividade: [
        { id: '01', descricao: 'Reunião de equipe' },
        { id: '02', descricao: 'Reunião com outras equipes de saúde' },
        {
          id: '03',
          descricao:
            'Reunião intersetorial / Conselho local de saúde / Controle social',
        },
      ],
      opcoesTemasReuniao: [
        { id: 1, descricao: 'Questões administrativas / Funcionamento' },
        { id: 2, descricao: 'Processos de trabalho' },
        {
          id: 3,
          descricao: 'Diagnóstico do território / Monitoramento do território',
        },
        {
          id: 4,
          descricao: 'Planejamento / Monitoramento das ações da equipe',
        },
        {
          id: 5,
          descricao: 'Discussão de caso / Projeto terapêutico singular',
        },
        { id: 6, descricao: 'Educação permanente' },
        { id: 7, descricao: 'Outros' },
      ],
      opcoesTemasParaSaude: [
        { id: 1, descricao: 'Ações de combate ao Aedes aegypti' },
        { id: 2, descricao: 'Agravos e Doenças Negligenciadas' },
        { id: 3, descricao: 'Alimentação saudável' },
        { id: 4, descricao: 'Autocuidado de pessoas com doenças crônicas' },
        { id: 5, descricao: 'Cidadania e direitos humanos' },
        {
          id: 6,
          descricao: 'Prevenção ao uso de álcool, tabaco e outras drogas',
        },
        { id: 7, descricao: 'Envelhecimento (climatério, andropausa, etc)' },
        { id: 8, descricao: 'Plantas medicinais / Fitoterapia' },
        {
          id: 9,
          descricao: 'Prevenção da violência e promoção da cultura da paz',
        },
        { id: 10, descricao: 'Saúde ambiental' },
        { id: 11, descricao: 'Saúde bucal' },
        { id: 12, descricao: 'Saúde do trabalhador' },
        { id: 13, descricao: 'Saúde mental' },
        { id: 14, descricao: 'Saúde sexual e reprodutiva' },
        { id: 15, descricao: 'Pessoas com sofrimento ou transtorno mental' },
        { id: 16, descricao: 'Outros' },
      ],
      opcoesPublicoAlvo: [
        { id: 1, descricao: 'Comunidade em geral' },
        { id: 2, descricao: 'Criança 0 a 3 anos' },
        { id: 3, descricao: 'Criança 4 a 5 anos' },
        { id: 4, descricao: 'Criança 6 a 11 anos' },
        { id: 5, descricao: 'Adolescente' },
        { id: 6, descricao: 'Mulher' },
        { id: 7, descricao: 'Gestante' },
        { id: 8, descricao: 'Homem' },
        { id: 9, descricao: 'Familiares' },
        { id: 10, descricao: 'Idoso' },
        { id: 11, descricao: 'Pessoas com doenças crônicas' },
        { id: 12, descricao: 'Usuário de tabaco' },
        { id: 13, descricao: 'Usuário de álcool' },
        { id: 14, descricao: 'Usuário de outras drogas' },
        { id: 15, descricao: 'Pessoas com sofrimento ou transtorno mental' },
        { id: 16, descricao: 'Profissional de educação' },
        { id: 17, descricao: 'Outros' },
      ],
      opcoesPraticasEmSaude: [
        { id: 30, descricao: 'Prática coletiva de saúde' },
      ],
      opcoesProcedimentos: [
        {
          codigo: '01.01.02.011-2',
          descricao: 'AÇÃO COLETIVA DE PREVENÇÃO DE CÂNCER BUCAL',
        },
        {
          codigo: '01.01.04.003-2',
          descricao: 'COLETA EXTERNA DE LEITE MATERNO (POR DOADORA)',
        },
        {
          codigo: '01.01.02.008-2',
          descricao: 'EVIDENCIAÇÃO DE PLACA BACTERIANA',
        },
        { codigo: '01.01.05.015-1', descricao: 'OFICINA COLETIVA DE SHANTALA' },
        {
          codigo: '01.01.05.005-4',
          descricao: 'OFICINA DE MASSAGEM/ AUTO-MASSAGEM',
        },
        {
          codigo: '01.01.04.004-0',
          descricao: 'PASTEURIZAÇÃO DO LEITE HUMANO (CADA 5 LITROS)',
        },
        {
          codigo: '01.01.01.003-6',
          descricao: 'PRÁTICA CORPORAL / ATIVIDADE FÍSICA EM GRUPO',
        },
        {
          codigo: '03.01.08.027-5',
          descricao: 'PRÁTICAS CORPORAIS EM CENTRO DE ATENÇÃO PSICOSSOCIAL',
        },
        {
          codigo: '01.01.05.001-1',
          descricao: 'PRÁTICAS CORPORAIS EM MEDICINA TRADICIONAL CHINESA',
        },
        {
          codigo: '03.01.08.028-3',
          descricao: 'PRÁTICAS EXPRESSIVAS E COMUNICATIVAS EM CAPS',
        },
        {
          codigo: '01.01.01.009-5',
          descricao: 'PREVENÇÃO AO COVID-19 NAS ESCOLAS',
        },
        { codigo: '01.01.05.006-2', descricao: 'SESSÃO DE ARTETERAPIA' },
        { codigo: '01.01.05.011-9', descricao: 'SESSÃO DE BIOENERGÉTICA' },
        { codigo: '01.01.05.010-0', descricao: 'SESSÃO DE BIODANÇA' },
        {
          codigo: '01.01.05.012-7',
          descricao: 'SESSÃO DE CONSTELAÇÃO FAMILIAR',
        },
        { codigo: '01.01.05.013-5', descricao: 'SESSÃO DE DANÇA CIRCULAR' },
        { codigo: '01.01.05.007-0', descricao: 'SESSÃO DE MEDITAÇÃO' },
        { codigo: '01.01.05.008-9', descricao: 'SESSÃO DE MUSICOTERAPIA' },
        { codigo: '08.04.02.005-1', descricao: 'TELEATENDIMENTO EM GRUPO' },
        { codigo: '01.01.05.002-0', descricao: 'TERAPIA COMUNITÁRIA' },
        {
          codigo: '03.07.01.007-4',
          descricao: 'TRATAMENTO RESTAURADOR ATRAUMÁTICO (TRA/ART)',
        },
        { codigo: '01.01.05.004-6', descricao: 'YOGA' },
      ],
      erros: {
        tipoAtividade: null,
        temaReuniao: null,
        temasParaSaude: null,
        publicoAlvo: null,
        participantes: null,
        praticasEmSaude: null,
      },
      novoParticipante: {
        cidadao: null,
        avaliacaoAlterada: false,
      },
      cidadaosDisponiveis: [],
      isLoadingCidadaos: false,
      erroResponsavel: null,
      carregandoEdicao: false,
      formData: {
        uuidDadoSerializado: this.gerarUuidDadoSerializado(
          this.$store.state.nu_cnes || '0000000'
        ),
        tipoDadoSerializado: '3',
        codIbge: this.$store.state.cod_ibge || '0000000',
        cnesDadoSerializado: this.$store.state.nu_cnes || '0000000',
        ineDadoSerializado: this.$store.state.nu_ine || '0000000000',
        numLote: '4',
        fichaAtividadeColetivaTransport: {
          data: '',
          numeroParticipantes: 0,
          turno: '',
          horaInicio: '',
          horaFim: '',
          qtdHoras: 1,
          tipo: null,
          forma: '',
          localAtividade: '',
          cnes: '',
          inep: '',
          outraLocalidade: '',
          programaEducacao: false,
          programaSaude: false,
          profissionais: [],
          atividadeTipo: null,
          temasParaReuniao: [],
          temasParaSaude: [],
          publicoAlvo: [],
          praticasEmSaude: [],
          procedimento: null,
          anotacoes: '',
          participantes: [],
        },
      },
    }
  },
  computed: {
    caracteresRestantesAnotacoes() {
      const atual = this.formData.fichaAtividadeColetivaTransport.anotacoes
        ? this.formData.fichaAtividadeColetivaTransport.anotacoes.length
        : 0
      return atual
    },
    // Validação condicional: temasParaReuniao é obrigatório se atividadeTipo = 1, 2 ou 3
    isTemaReuniaoObrigatorio() {
      const tipo = this.formData.fichaAtividadeColetivaTransport.atividadeTipo
      return tipo && ['01', '02', '03'].includes(tipo.id)
    },
    // Validação condicional: temasParaSaude é obrigatório se atividadeTipo = 4, 5 ou 7
    isTemasParaSaudeObrigatorio() {
      const tipo = this.formData.fichaAtividadeColetivaTransport.atividadeTipo
      return tipo && ['04', '05', '07'].includes(tipo.id)
    },
    // Validação condicional: publicoAlvo é obrigatório se atividadeTipo = 4, 5, 6 ou 7
    isPublicoAlvoObrigatorio() {
      const tipo = this.formData.fichaAtividadeColetivaTransport.atividadeTipo
      return tipo && ['04', '05', '06', '07'].includes(tipo.id)
    },
    // Validação condicional: participantes é obrigatório se atividadeTipo = 5 ou 6
    isParticipantesObrigatorio() {
      const tipo = this.formData.fichaAtividadeColetivaTransport.atividadeTipo
      // Aceita tanto string quanto objeto com id
      if (!tipo) return false
      const tipoId = typeof tipo === 'object' ? tipo.id : tipo
      return ['05', '06', 5, 6].includes(tipoId)
    },
    // Validação condicional: praticasEmSaude é obrigatório se atividadeTipo = 6
    isPraticasEmSaudeObrigatorio() {
      const tipo = this.formData.fichaAtividadeColetivaTransport.atividadeTipo
      return tipo && tipo.id === '06'
    },
    // Mostrar campo procedimento se praticasEmSaude contém valor 30
    mostrarProcedimento() {
      const praticas =
        this.formData.fichaAtividadeColetivaTransport.praticasEmSaude || []
      return praticas.some((p) => {
        const id = typeof p === 'object' ? p.id : p
        return id === 30
      })
    },
  },
  async created() {
    await this.buscarCpfUsuario()
    const idAtividade = this.$route.query.id
    if (idAtividade) {
      await this.carregarAtividadeParaEdicao(idAtividade)
    } else {
      await this.inicializarFormularioVazio()
    }
  },

  methods: {
    async buscarCpfUsuario() {
      try {
        const userAuth = await this.$api.post('/app/auth/usuario', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (userAuth && userAuth.data) {
          this.cpf = userAuth.data.cpf
        }
      } catch (error) {}
      if (!this.cpf && this.$store.state.accessToken) {
        try {
          const decoded = jwtDecode(this.$store.state.accessToken)
          this.cpf = decoded.nu_cpf || decoded.cpf || null
        } catch (e) {}
      }
    },
    async inicializarFormularioVazio() {
      if (this.$store.state.accessToken) {
        const decoded = jwtDecode(this.$store.state.accessToken)

        this.formData.codIbge = decoded.cod_ibge || this.formData.codIbge
        this.formData.cnesDadoSerializado =
          decoded.nu_cnes || this.formData.cnesDadoSerializado
        this.formData.ineDadoSerializado =
          decoded.nu_ine || this.formData.ineDadoSerializado
        this.formData.uuidDadoSerializado = this.gerarUuidDadoSerializado(
          decoded.nu_cnes || '0000000'
        )

        // Busca dados completos do profissional logado para obter no_unidade_saude
        let profissionalCompleto = null
        if (this.cpf || decoded.nu_cns) {
          try {
            const codIbge = decoded.cod_ibge || this.$store.state.cod_ibge || ''
            if (codIbge) {
              const response = await this.$api.get(
                `/app/profissionais-lotacoes/${codIbge}/1`
              )
              const profissionais = Array.isArray(response.data)
                ? response.data
                : []

              const cpfLimpo = this.cpf
                ? String(this.cpf).replace(/\D/g, '')
                : ''
              const cnsLimpo = decoded.nu_cns
                ? String(decoded.nu_cns).replace(/\D/g, '')
                : ''

              profissionalCompleto = profissionais.find((prof) => {
                const profCpf = prof.nu_cpf
                  ? String(prof.nu_cpf).replace(/\D/g, '')
                  : ''
                const profCns = prof.nu_cns
                  ? String(prof.nu_cns).replace(/\D/g, '')
                  : ''
                return (
                  (cpfLimpo && profCpf === cpfLimpo) ||
                  (cnsLimpo && profCns === cnsLimpo)
                )
              })
            }
          } catch (error) {
            // Erro ao buscar dados completos do profissional logado
          }
        }

        // Extrai dados da lotação ativa se encontrou o profissional
        let lotacaoAtiva = null
        let no_unidade_saude = null
        if (profissionalCompleto && profissionalCompleto.lotacoes) {
          try {
            const lotacoes = JSON.parse(profissionalCompleto.lotacoes)
            if (Array.isArray(lotacoes) && lotacoes.length > 0) {
              lotacaoAtiva =
                lotacoes.find((l) => l.st_ativo === 1) || lotacoes[0]
              no_unidade_saude = lotacaoAtiva?.no_unidade_saude || null
            }
          } catch (e) {
            // Erro ao fazer parse de 'lotacoes'
          }
        }

        // Adiciona o profissional logado na lista, mas sem marcá-lo como responsável
        this.formData.fichaAtividadeColetivaTransport.profissionais = [
          {
            nome:
              decoded.nome && decoded.nome.trim() !== ''
                ? decoded.nome
                : 'Profissional',
            no_profissional:
              decoded.nome && decoded.nome.trim() !== ''
                ? decoded.nome
                : 'Profissional',
            nu_cpf: this.cpf || null,
            no_cbo:
              (lotacaoAtiva && lotacaoAtiva.no_cbo) ||
              profissionalCompleto?.no_cbo ||
              decoded.funcao ||
              null,
            nu_cnes:
              (lotacaoAtiva && lotacaoAtiva.nu_cnes) ||
              (decoded.nu_cnes && decoded.nu_cnes.trim() !== '')
                ? decoded.nu_cnes
                : null,
            no_unidade_saude: no_unidade_saude || null,
            nu_ine:
              (lotacaoAtiva && lotacaoAtiva.nu_ine) ||
              (decoded.nu_ine && decoded.nu_ine.trim() !== '')
                ? decoded.nu_ine
                : null,
            cnsProfissional:
              (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
              profissionalCompleto?.nu_cns ||
              (decoded.nu_cns && decoded.nu_cns.trim() !== ''
                ? decoded.nu_cns
                : null),
            nu_cns:
              (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
              profissionalCompleto?.nu_cns ||
              (decoded.nu_cns && decoded.nu_cns.trim() !== ''
                ? decoded.nu_cns
                : null),
            cns:
              (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
              profissionalCompleto?.nu_cns ||
              (decoded.nu_cns && decoded.nu_cns.trim() !== ''
                ? decoded.nu_cns
                : null),
            id_funcao:
              (lotacaoAtiva && lotacaoAtiva.co_cbo) ||
              profissionalCompleto?.co_cbo ||
              decoded.id_funcao ||
              decoded.co_cbo ||
              '2',
            co_cbo:
              (lotacaoAtiva && lotacaoAtiva.co_cbo) ||
              profissionalCompleto?.co_cbo ||
              decoded.co_cbo ||
              decoded.id_funcao ||
              '2',
            selecionado: true,
            logado: false, // Não marca como responsável automaticamente
            isResponsavel: false, // Não marca como responsável automaticamente
          },
        ]

        // Atualiza o número de participantes baseado na quantidade de profissionais
        const totalProfissionais =
          this.formData.fichaAtividadeColetivaTransport.profissionais.length
        this.formData.fichaAtividadeColetivaTransport.numeroParticipantes =
          totalProfissionais
        this.$nextTick(() => {
          if (this.$refs.cabecalho) {
            this.$refs.cabecalho.formData.numeroParticipantes =
              totalProfissionais
          }
        })
      } else {
        // Nenhum token de acesso encontrado na store
      }
    },
    async carregarAtividadeParaEdicao(id) {
      this.carregandoEdicao = true
      try {
        this.formData.fichaAtividadeColetivaTransport.profissionais = []

        const ibge = this.$store.state.cod_ibge || ''
        const endpoint = `/app/oficinas-treinamentos/${ibge}/oficinas/${id}`
        const response = await this.$api.get(endpoint)

        if (response && response.data && response.data.data) {
          const oficina = response.data.data
          const fichaAtividadeColetiva = oficina.ficha_atividade_coletiva || {}

          // Faz parse dos dados da ficha (que vem como string JSON)
          let dadosFicha = {}
          if (fichaAtividadeColetiva.dados) {
            try {
              dadosFicha =
                typeof fichaAtividadeColetiva.dados === 'string'
                  ? JSON.parse(fichaAtividadeColetiva.dados)
                  : fichaAtividadeColetiva.dados
            } catch (e) {
              // Erro ao fazer parse dos dados da ficha
            }
          }

          // Combina os dados da oficina com os dados parseados da ficha
          const atividade = {
            ...oficina,
            ...dadosFicha,
            ficha_atividade_coletiva: fichaAtividadeColetiva,
          }

          await this.preencherFormularioComDados(atividade)
        } else {
          this.$toast.error(
            'Não foi possível carregar os dados da atividade',
            'Erro'
          )
          this.$router.push('/oficinas-treinamentos')
        }
      } catch (error) {
        let mensagemErro = 'Erro ao carregar dados da atividade'
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          mensagemErro = error.response.data.message
        }
        this.$toast.error(mensagemErro, 'Erro')
        this.$router.push('/oficinas-treinamentos')
      } finally {
        this.carregandoEdicao = false
      }
    },
    async preencherFormularioComDados(atividade) {
      try {
        this.formData.fichaAtividadeColetivaTransport.profissionais = []

        if (atividade.ibge) {
          this.formData.codIbge = atividade.ibge
        }

        if (atividade.inicio) {
          const dataInicio = new Date(atividade.inicio)
          const dataFormatada = dataInicio.toISOString().split('T')[0]
          this.formData.fichaAtividadeColetivaTransport.data = dataFormatada

          await this.$nextTick()
          if (this.$refs.cabecalho) {
            this.$refs.cabecalho.formData.data = dataFormatada
            this.$refs.cabecalho.dataFormatada =
              dataInicio.toLocaleDateString('pt-BR')
          }
        }

        if (atividade.inicio) {
          const horaInicio = new Date(atividade.inicio)
            .toTimeString()
            .slice(0, 5)
          this.formData.fichaAtividadeColetivaTransport.horaInicio = horaInicio
        }

        if (atividade.fim) {
          const horaFim = new Date(atividade.fim).toTimeString().slice(0, 5)
          this.formData.fichaAtividadeColetivaTransport.horaFim = horaFim
        }

        if (atividade.qtd_horas !== undefined && atividade.qtd_horas !== null) {
          const qtdHoras = Number(atividade.qtd_horas)
          if (qtdHoras >= 1 && qtdHoras <= 8) {
            this.formData.fichaAtividadeColetivaTransport.qtdHoras = qtdHoras
            if (this.$refs.cabecalho) {
              this.$refs.cabecalho.formData.qtdHoras = qtdHoras
            }
          }
        }

        if (atividade.id_catalogo_ofici_treinam) {
          this.formData.fichaAtividadeColetivaTransport.tipo =
            atividade.id_catalogo_ofici_treinam
          await this.$nextTick()
          if (this.$refs.cabecalho) {
            this.$refs.cabecalho.formData.tipo =
              atividade.id_catalogo_ofici_treinam
            await this.$refs.cabecalho.carregarTipos()
            const tipo = this.$refs.cabecalho.tiposDisponiveis.find(
              (t) => t.id === atividade.id_catalogo_ofici_treinam
            )
            if (tipo) {
              this.$refs.cabecalho.tipoSelecionado = tipo
            }
          }
        }

        if (atividade.meio) {
          const formaMap = {
            Presencial: 'presencial',
            Telepresença: 'telepresenca',
            '100% Online': 'online',
          }
          this.formData.fichaAtividadeColetivaTransport.forma =
            formaMap[atividade.meio] || atividade.meio.toLowerCase()
        }

        // Campos que vêm do JSON parseado da ficha_atividade_coletiva.dados
        if (atividade.turno !== undefined && atividade.turno !== null) {
          this.formData.fichaAtividadeColetivaTransport.turno = String(
            atividade.turno
          )
        }

        if (atividade.pseSaude !== undefined) {
          this.formData.fichaAtividadeColetivaTransport.programaSaude =
            atividade.pseSaude
        }

        if (atividade.pseEducacao !== undefined) {
          this.formData.fichaAtividadeColetivaTransport.programaEducacao =
            atividade.pseEducacao
        }

        if (
          atividade.atividadeTipo !== undefined &&
          atividade.atividadeTipo !== null
        ) {
          const raw = atividade.atividadeTipo
          const idNormalizado =
            raw === null || raw === undefined
              ? null
              : String(raw).length === 1
              ? String(raw).padStart(2, '0') // 3 -> "03"
              : String(raw) // "03" ou "01"

          const tipoObj =
            this.opcoesTipoAtividade.find(
              (opt) => String(opt.id) === String(idNormalizado)
            ) ||
            this.opcoesTipoAtividade.find(
              (opt) => String(opt.id) === String(raw)
            ) ||
            null

          this.formData.fichaAtividadeColetivaTransport.atividadeTipo =
            tipoObj || raw
        }

        if (
          atividade.temasParaReuniao &&
          Array.isArray(atividade.temasParaReuniao)
        ) {
          const temasIds = atividade.temasParaReuniao
            .map((t) => (t && typeof t === 'object' ? t.id : t))
            .filter((t) => t !== null && t !== undefined)
          this.formData.fichaAtividadeColetivaTransport.temasParaReuniao =
            temasIds
              .map(
                (id) =>
                  this.opcoesTemasReuniao.find(
                    (opt) => String(opt.id) === String(id)
                  ) || id
              )
              .filter(Boolean)
        }

        if (
          atividade.temasParaSaude &&
          Array.isArray(atividade.temasParaSaude)
        ) {
          const ids = atividade.temasParaSaude
            .map((t) => (t && typeof t === 'object' ? t.id : t))
            .filter((t) => t !== null && t !== undefined)
          this.formData.fichaAtividadeColetivaTransport.temasParaSaude = ids
            .map(
              (id) =>
                this.opcoesTemasParaSaude.find(
                  (opt) => String(opt.id) === String(id)
                ) || id
            )
            .filter(Boolean)
        }

        if (atividade.publicoAlvo && Array.isArray(atividade.publicoAlvo)) {
          const ids = atividade.publicoAlvo
            .map((t) => (t && typeof t === 'object' ? t.id : t))
            .filter((t) => t !== null && t !== undefined)
          this.formData.fichaAtividadeColetivaTransport.publicoAlvo = ids
            .map(
              (id) =>
                this.opcoesPublicoAlvo.find(
                  (opt) => String(opt.id) === String(id)
                ) || id
            )
            .filter(Boolean)
        }

        if (
          atividade.praticasEmSaude &&
          Array.isArray(atividade.praticasEmSaude)
        ) {
          const ids = atividade.praticasEmSaude
            .map((t) => (t && typeof t === 'object' ? t.id : t))
            .filter((t) => t !== null && t !== undefined)
          this.formData.fichaAtividadeColetivaTransport.praticasEmSaude = ids
            .map(
              (id) =>
                this.opcoesPraticasEmSaude.find(
                  (opt) => String(opt.id) === String(id)
                ) || id
            )
            .filter(Boolean)
        }

        if (
          atividade.procedimento !== undefined &&
          atividade.procedimento !== null
        ) {
          this.formData.fichaAtividadeColetivaTransport.procedimento =
            atividade.procedimento
        }

        if (atividade.anotacoes !== undefined) {
          this.formData.fichaAtividadeColetivaTransport.anotacoes =
            atividade.anotacoes || ''
        }

        // UUID da ficha
        if (
          atividade.ficha_atividade_coletiva &&
          atividade.ficha_atividade_coletiva.nu_uuid_ficha
        ) {
          this.formData.uuidDadoSerializado =
            atividade.ficha_atividade_coletiva.nu_uuid_ficha
        } else if (atividade.uuidFicha) {
          this.formData.uuidDadoSerializado = atividade.uuidFicha
        }

        await this.$nextTick()

        // Prioriza profissionais do JSON parseado, senão usa participantes da API
        if (
          atividade.profissionais &&
          Array.isArray(atividade.profissionais) &&
          atividade.profissionais.length > 0
        ) {
          // Usa profissionais do JSON parseado (dadosFicha.profissionais) e enriquece com dados completos
          await this.enriquecerDadosProfissionaisDoJSON(
            atividade.profissionais,
            atividade.cpf_facilitador
          )
          this.formData.fichaAtividadeColetivaTransport.numeroParticipantes =
            this.formData.fichaAtividadeColetivaTransport.profissionais.length
        } else if (
          atividade.participantes &&
          Array.isArray(atividade.participantes) &&
          atividade.participantes.length > 0
        ) {
          // Fallback: usa participantes da API e enriquece dados
          await this.enriquecerDadosProfissionais(
            atividade.participantes,
            atividade.cpf_facilitador
          )
          this.formData.fichaAtividadeColetivaTransport.numeroParticipantes =
            this.formData.fichaAtividadeColetivaTransport.profissionais.length
        } else {
          this.formData.fichaAtividadeColetivaTransport.profissionais = []
          this.formData.fichaAtividadeColetivaTransport.numeroParticipantes = 0
        }

        // Atualiza o número de participantes no componente cabecalho
        if (this.$refs.cabecalho) {
          this.$refs.cabecalho.formData.numeroParticipantes =
            this.formData.fichaAtividadeColetivaTransport.numeroParticipantes
        }

        if (this.$refs.profissionais) {
          this.$refs.profissionais.profissionaisLocal = [
            ...this.formData.fichaAtividadeColetivaTransport.profissionais,
          ]
        }

        // Carrega local da atividade: CNES, INEP ou Outra Localidade (mutuamente exclusivos)
        const cnesSalvo =
          atividade.cnesLocalAtividade ||
          (atividade.headerTransport && atividade.headerTransport.cnes)
        const inepSalvo =
          atividade.inep ||
          (atividade.headerTransport && atividade.headerTransport.ine)
        const outraLocalidadeSalva =
          atividade.outraLocalidade &&
          String(atividade.outraLocalidade).trim() !== ''

        if (outraLocalidadeSalva) {
          // Outra localidade preenchida
          this.formData.fichaAtividadeColetivaTransport.outraLocalidade =
            atividade.outraLocalidade
          this.formData.fichaAtividadeColetivaTransport.localAtividade = 'outro'
          await this.$nextTick()
          if (this.$refs.cabecalho) {
            this.$refs.cabecalho.formData.outraLocalidade =
              atividade.outraLocalidade
            this.$refs.cabecalho.formData.localAtividade = 'outro'
          }
        } else if (inepSalvo) {
          // INEP preenchido
          this.formData.fichaAtividadeColetivaTransport.inep = inepSalvo
          this.formData.fichaAtividadeColetivaTransport.localAtividade =
            'escola'
          await this.$nextTick()
          if (this.$refs.cabecalho) {
            this.$refs.cabecalho.formData.inep = inepSalvo
            this.$refs.cabecalho.formData.localAtividade = 'escola'
            await this.$refs.cabecalho.carregarEscolas()
            const escola = this.$refs.cabecalho.escolas.find(
              (e) => e.nu_inep === inepSalvo || e.label === inepSalvo
            )
            if (escola) {
              this.$refs.cabecalho.inepSelecionado = escola
            }
          }
        } else if (cnesSalvo) {
          // Usa o CNES salvo na ficha
          this.formData.fichaAtividadeColetivaTransport.cnes = cnesSalvo
          this.formData.fichaAtividadeColetivaTransport.localAtividade =
            'unidade'
          await this.$nextTick()
          if (this.$refs.cabecalho) {
            this.$refs.cabecalho.formData.cnes = cnesSalvo
            this.$refs.cabecalho.formData.localAtividade = 'unidade'
            await this.$refs.cabecalho.carregarEstabelecimentos()
            const estabelecimento = this.$refs.cabecalho.estabelecimentos.find(
              (est) => est.nu_cnes === cnesSalvo
            )
            if (estabelecimento) {
              this.$refs.cabecalho.cnesSelecionado = estabelecimento
            } else {
              // Se não encontrou na lista, cria um objeto temporário para exibir
              const novoEstabelecimento = {
                nu_cnes: cnesSalvo,
                no_unidade_saude: 'Unidade não encontrada',
                label: `${cnesSalvo} - Unidade não encontrada`,
              }
              this.$refs.cabecalho.estabelecimentos.push(novoEstabelecimento)
              this.$refs.cabecalho.cnesSelecionado = novoEstabelecimento
            }
          }
        } else if (
          this.formData.fichaAtividadeColetivaTransport.profissionais.length > 0
        ) {
          // Fallback: usa o CNES do responsável apenas se não houver CNES salvo
          const responsavel =
            this.formData.fichaAtividadeColetivaTransport.profissionais[0]
          if (responsavel.nu_cnes) {
            this.formData.fichaAtividadeColetivaTransport.cnes =
              responsavel.nu_cnes
            await this.$nextTick()
            if (this.$refs.cabecalho) {
              this.$refs.cabecalho.formData.cnes = responsavel.nu_cnes
              await this.$refs.cabecalho.carregarEstabelecimentos()
              const estabelecimento =
                this.$refs.cabecalho.estabelecimentos.find(
                  (est) => est.nu_cnes === responsavel.nu_cnes
                )
              if (estabelecimento) {
                this.$refs.cabecalho.cnesSelecionado = estabelecimento
              } else if (responsavel.no_unidade_saude) {
                const novoEstabelecimento = {
                  nu_cnes: responsavel.nu_cnes,
                  no_unidade_saude: responsavel.no_unidade_saude,
                  label: `${responsavel.nu_cnes} - ${responsavel.no_unidade_saude}`,
                }
                this.$refs.cabecalho.estabelecimentos.push(novoEstabelecimento)
                this.$refs.cabecalho.cnesSelecionado = novoEstabelecimento
              }
            }
          }
        }
      } catch (error) {
        // Se houver erro ao preencher os dados, redireciona para a listagem
        let mensagemErro = 'Erro ao carregar dados da atividade'
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          mensagemErro = error.response.data.message
        }
        this.$toast.error(mensagemErro, 'Erro')
        this.$router.push('/oficinas-treinamentos')
        throw error // Re-lança o erro para que o método carregarAtividadeParaEdicao também trate
      }
    },
    async enriquecerDadosProfissionais(participantes, cpfFacilitador = null) {
      try {
        const codIbge =
          this.formData.codIbge || this.$store.state.cod_ibge || ''
        if (!codIbge) {
          this.formData.fichaAtividadeColetivaTransport.profissionais =
            participantes.map((p) => ({
              nome: p.nome_participante || '',
              no_profissional: p.nome_participante || '',
              nu_cpf: p.cpf_participante || null,
              cnsProfissional: null,
              nu_cns: null,
              cns: null,
              selecionado: true,
              logado: false,
            }))
          this.ordenarProfissionaisPorResponsavel(cpfFacilitador)
          return
        }

        const response = await this.$api.get(
          `/app/profissionais-lotacoes/${codIbge}/1`
        )
        const profissionaisDisponiveis = Array.isArray(response.data)
          ? response.data
          : []

        this.formData.fichaAtividadeColetivaTransport.profissionais =
          participantes.map((p) => {
            const cpfLimpo = p.cpf_participante
              ? String(p.cpf_participante).replace(/\D/g, '')
              : ''

            const profissionalCompleto = profissionaisDisponiveis.find(
              (prof) => {
                const profCpf = prof.nu_cpf
                  ? String(prof.nu_cpf).replace(/\D/g, '')
                  : ''
                return profCpf === cpfLimpo
              }
            )

            if (profissionalCompleto) {
              let lotacoes = []
              if (profissionalCompleto.lotacoes) {
                try {
                  lotacoes = JSON.parse(profissionalCompleto.lotacoes)
                } catch (e) {
                  // Erro ao fazer parse de 'lotacoes'
                }
              }

              const lotacaoAtiva =
                Array.isArray(lotacoes) && lotacoes.length > 0
                  ? lotacoes.find((l) => l.st_ativo === 1) || lotacoes[0]
                  : null

              return {
                nome:
                  p.nome_participante ||
                  profissionalCompleto.no_profissional ||
                  '',
                no_profissional:
                  p.nome_participante ||
                  profissionalCompleto.no_profissional ||
                  '',
                nu_cpf:
                  p.cpf_participante || profissionalCompleto.nu_cpf || null,
                cnsProfissional:
                  profissionalCompleto.nu_cns ||
                  (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
                  null,
                nu_cns:
                  profissionalCompleto.nu_cns ||
                  (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
                  null,
                cns:
                  profissionalCompleto.nu_cns ||
                  (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
                  null,
                no_cbo:
                  (lotacaoAtiva && lotacaoAtiva.no_cbo) ||
                  profissionalCompleto.no_cbo ||
                  null,
                id_funcao: (lotacaoAtiva && lotacaoAtiva.co_cbo) || null,
                co_cbo: (lotacaoAtiva && lotacaoAtiva.co_cbo) || null,
                nu_cnes: (lotacaoAtiva && lotacaoAtiva.nu_cnes) || null,
                no_unidade_saude:
                  (lotacaoAtiva && lotacaoAtiva.no_unidade_saude) || null,
                nu_ine: (lotacaoAtiva && lotacaoAtiva.nu_ine) || null,
                selecionado: true,
                logado: false,
              }
            } else {
              return {
                nome: p.nome_participante || '',
                no_profissional: p.nome_participante || '',
                nu_cpf: p.cpf_participante || null,
                cnsProfissional: null,
                nu_cns: null,
                cns: null,
                selecionado: true,
                logado: false,
              }
            }
          })

        this.ordenarProfissionaisPorResponsavel(cpfFacilitador)
      } catch (error) {
        this.formData.fichaAtividadeColetivaTransport.profissionais =
          participantes.map((p) => ({
            nome: p.nome_participante || '',
            no_profissional: p.nome_participante || '',
            nu_cpf: p.cpf_participante || null,
            cnsProfissional: null,
            nu_cns: null,
            cns: null,
            selecionado: true,
            logado: false,
          }))
        this.ordenarProfissionaisPorResponsavel(cpfFacilitador)
      }
    },
    async enriquecerDadosProfissionaisDoJSON(
      profissionaisJSON,
      cpfFacilitador = null
    ) {
      try {
        const codIbge =
          this.formData.codIbge || this.$store.state.cod_ibge || ''
        if (!codIbge) {
          // Se não tiver IBGE, usa os dados básicos do JSON
          this.formData.fichaAtividadeColetivaTransport.profissionais =
            profissionaisJSON.map((prof) => ({
              nome: prof.no_profissional || '',
              no_profissional: prof.no_profissional || '',
              nu_cpf: prof.nu_cpf || null,
              cnsProfissional: prof.cnsProfissional || null,
              nu_cns: prof.cnsProfissional || null,
              cns: prof.cnsProfissional || null,
              id_funcao: prof.codigoCbo2002 || null,
              co_cbo: prof.codigoCbo2002 || null,
              no_cbo: null,
              nu_cnes: null,
              no_unidade_saude: null,
              nu_ine: null,
              selecionado: true,
              logado: false,
            }))
          this.ordenarProfissionaisPorResponsavel(cpfFacilitador)
          return
        }

        const response = await this.$api.get(
          `/app/profissionais-lotacoes/${codIbge}/1`
        )
        const profissionaisDisponiveis = Array.isArray(response.data)
          ? response.data
          : []

        this.formData.fichaAtividadeColetivaTransport.profissionais =
          profissionaisJSON.map((prof) => {
            const cpfLimpo = prof.nu_cpf
              ? String(prof.nu_cpf).replace(/\D/g, '')
              : ''

            const profissionalCompleto = profissionaisDisponiveis.find(
              (profCompleto) => {
                const profCpf = profCompleto.nu_cpf
                  ? String(profCompleto.nu_cpf).replace(/\D/g, '')
                  : ''
                return profCpf === cpfLimpo
              }
            )

            if (profissionalCompleto) {
              let lotacoes = []
              if (profissionalCompleto.lotacoes) {
                try {
                  lotacoes = JSON.parse(profissionalCompleto.lotacoes)
                } catch (e) {
                  // Erro ao fazer parse de 'lotacoes'
                }
              }

              const lotacaoAtiva =
                Array.isArray(lotacoes) && lotacoes.length > 0
                  ? lotacoes.find((l) => l.st_ativo === 1) || lotacoes[0]
                  : null

              return {
                nome:
                  prof.no_profissional ||
                  profissionalCompleto.no_profissional ||
                  '',
                no_profissional:
                  prof.no_profissional ||
                  profissionalCompleto.no_profissional ||
                  '',
                nu_cpf: prof.nu_cpf || profissionalCompleto.nu_cpf || null,
                cnsProfissional:
                  prof.cnsProfissional ||
                  profissionalCompleto.nu_cns ||
                  (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
                  null,
                nu_cns:
                  prof.cnsProfissional ||
                  profissionalCompleto.nu_cns ||
                  (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
                  null,
                cns:
                  prof.cnsProfissional ||
                  profissionalCompleto.nu_cns ||
                  (lotacaoAtiva && lotacaoAtiva.nu_cns) ||
                  null,
                no_cbo:
                  (lotacaoAtiva && lotacaoAtiva.no_cbo) ||
                  profissionalCompleto.no_cbo ||
                  null,
                id_funcao:
                  prof.codigoCbo2002 ||
                  (lotacaoAtiva && lotacaoAtiva.co_cbo) ||
                  null,
                co_cbo:
                  prof.codigoCbo2002 ||
                  (lotacaoAtiva && lotacaoAtiva.co_cbo) ||
                  null,
                nu_cnes: (lotacaoAtiva && lotacaoAtiva.nu_cnes) || null,
                no_unidade_saude:
                  (lotacaoAtiva && lotacaoAtiva.no_unidade_saude) || null,
                nu_ine: (lotacaoAtiva && lotacaoAtiva.nu_ine) || null,
                selecionado: true,
                logado: false,
              }
            } else {
              // Se não encontrou na API, usa os dados do JSON
              return {
                nome: prof.no_profissional || '',
                no_profissional: prof.no_profissional || '',
                nu_cpf: prof.nu_cpf || null,
                cnsProfissional: prof.cnsProfissional || null,
                nu_cns: prof.cnsProfissional || null,
                cns: prof.cnsProfissional || null,
                id_funcao: prof.codigoCbo2002 || null,
                co_cbo: prof.codigoCbo2002 || null,
                no_cbo: null,
                nu_cnes: null,
                no_unidade_saude: null,
                nu_ine: null,
                selecionado: true,
                logado: false,
              }
            }
          })

        this.ordenarProfissionaisPorResponsavel(cpfFacilitador)
      } catch (error) {
        // Em caso de erro, usa os dados básicos do JSON
        this.formData.fichaAtividadeColetivaTransport.profissionais =
          profissionaisJSON.map((prof) => ({
            nome: prof.no_profissional || '',
            no_profissional: prof.no_profissional || '',
            nu_cpf: prof.nu_cpf || null,
            cnsProfissional: prof.cnsProfissional || null,
            nu_cns: prof.cnsProfissional || null,
            cns: prof.cnsProfissional || null,
            id_funcao: prof.codigoCbo2002 || null,
            co_cbo: prof.codigoCbo2002 || null,
            no_cbo: null,
            nu_cnes: null,
            no_unidade_saude: null,
            nu_ine: null,
            selecionado: true,
            logado: false,
          }))
        this.ordenarProfissionaisPorResponsavel(cpfFacilitador)
      }
    },
    ordenarProfissionaisPorResponsavel(cpfFacilitador) {
      if (
        !cpfFacilitador ||
        !this.formData.fichaAtividadeColetivaTransport.profissionais.length
      ) {
        return
      }

      // Remove a marcação de responsável de todos os profissionais
      this.formData.fichaAtividadeColetivaTransport.profissionais.forEach(
        (prof) => {
          prof.logado = false
          prof.isResponsavel = false
        }
      )

      const cpfLimpo = String(cpfFacilitador).replace(/\D/g, '')

      const indexResponsavel =
        this.formData.fichaAtividadeColetivaTransport.profissionais.findIndex(
          (prof) => {
            const profCpf = prof.nu_cpf
              ? String(prof.nu_cpf).replace(/\D/g, '')
              : ''
            return profCpf === cpfLimpo
          }
        )

      if (indexResponsavel >= 0) {
        const responsavel =
          this.formData.fichaAtividadeColetivaTransport.profissionais[
            indexResponsavel
          ]

        // Marca o profissional como responsável
        responsavel.logado = true
        responsavel.isResponsavel = true

        // Move para o início da lista se não estiver já no início
        if (indexResponsavel > 0) {
          this.formData.fichaAtividadeColetivaTransport.profissionais.splice(
            indexResponsavel,
            1
          )
          this.formData.fichaAtividadeColetivaTransport.profissionais.unshift(
            responsavel
          )
        }
      }
    },
    gerarInconsistencias() {
      const inconsistencias = []

      // Validações do Cabeçalho (sem ativar mostrarErros - apenas verifica)
      const cabecalhoComponent = this.$refs.cabecalho
      if (cabecalhoComponent) {
        // Validações silenciosas (sem mostrar erros na tela)
        const isEditMode = !!this.$route.query.id
        const valorMinimoParticipantes = isEditMode ? 0 : 1

        const temErroData =
          !cabecalhoComponent.formData.data && !cabecalhoComponent.dataFormatada
        const temErroTurno = !cabecalhoComponent.formData.turno
        const temErroNumParticipantes =
          cabecalhoComponent.formData.numeroParticipantes === null ||
          cabecalhoComponent.formData.numeroParticipantes === undefined ||
          cabecalhoComponent.formData.numeroParticipantes <
            valorMinimoParticipantes
        const temErroHoraInicio = !cabecalhoComponent.formData.horaInicio
        const temErroHoraFim = !cabecalhoComponent.formData.horaFim
        const temErroForma = !cabecalhoComponent.formData.forma
        const temErroTipo =
          !cabecalhoComponent.formData.tipo &&
          !cabecalhoComponent.tipoSelecionado
        // Regra: preencher somente um dos campos (outraLocalidade, inep ou cnes)
        // CNES é obrigatório apenas quando nenhum dos outros está preenchido
        const temCnes =
          cabecalhoComponent.formData.cnes &&
          String(cabecalhoComponent.formData.cnes).trim() !== ''
        const temInep =
          cabecalhoComponent.formData.inep &&
          String(cabecalhoComponent.formData.inep).trim() !== ''
        const temOutraLocalidade =
          cabecalhoComponent.formData.outraLocalidade &&
          String(cabecalhoComponent.formData.outraLocalidade).trim() !== ''
        const temErroCnes = !temCnes && !temInep && !temOutraLocalidade

        if (temErroData)
          inconsistencias.push({ tab: 'Cabeçalho', campo: 'Data' })
        if (temErroTurno)
          inconsistencias.push({ tab: 'Cabeçalho', campo: 'Turno' })
        if (temErroNumParticipantes)
          inconsistencias.push({
            tab: 'Cabeçalho',
            campo: 'Número de Participantes',
          })
        if (temErroHoraInicio)
          inconsistencias.push({ tab: 'Cabeçalho', campo: 'Hora de início' })
        if (temErroHoraFim)
          inconsistencias.push({ tab: 'Cabeçalho', campo: 'Hora de fim' })
        if (temErroForma)
          inconsistencias.push({ tab: 'Cabeçalho', campo: 'Forma' })
        if (temErroTipo)
          inconsistencias.push({ tab: 'Cabeçalho', campo: 'Tipo' })
        if (temErroCnes)
          inconsistencias.push({
            tab: 'Cabeçalho',
            campo: 'Unidade Básica de Saúde (CNES)',
          })
      }

      // Validações do Tipo (também verifica no formData principal)
      if (
        !this.formData.fichaAtividadeColetivaTransport.atividadeTipo &&
        (!cabecalhoComponent || !cabecalhoComponent.formData.tipo)
      ) {
        inconsistencias.push({
          tab: 'Dados da Atividade',
          campo: 'Tipo da atividade',
        })
      }

      // Validações condicionais do Tema da Reunião (obrigatório se atividadeTipo = 1, 2 ou 3)
      if (this.isTemaReuniaoObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.temasParaReuniao ||
          this.formData.fichaAtividadeColetivaTransport.temasParaReuniao
            .length === 0
        ) {
          inconsistencias.push({
            tab: 'Dados da Atividade',
            campo: 'Tema da reunião',
          })
        }
      }

      // Validações condicionais dos Temas para a Saúde (obrigatório se atividadeTipo = 4, 5 ou 7)
      if (this.isTemasParaSaudeObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.temasParaSaude ||
          this.formData.fichaAtividadeColetivaTransport.temasParaSaude
            .length === 0
        ) {
          inconsistencias.push({
            tab: 'Dados da Atividade',
            campo: 'Temas para a saúde',
          })
        }
      }

      // Validações condicionais do Público-Alvo (obrigatório se atividadeTipo = 4, 5, 6 ou 7)
      if (this.isPublicoAlvoObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.publicoAlvo ||
          this.formData.fichaAtividadeColetivaTransport.publicoAlvo.length === 0
        ) {
          inconsistencias.push({
            tab: 'Dados da Atividade',
            campo: 'Público-alvo',
          })
        }
      }

      // Validações condicionais das Práticas em Saúde (obrigatório se atividadeTipo = 6)
      if (this.isPraticasEmSaudeObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.praticasEmSaude ||
          this.formData.fichaAtividadeColetivaTransport.praticasEmSaude
            .length === 0
        ) {
          inconsistencias.push({
            tab: 'Dados da Atividade',
            campo: 'Práticas em Saúde',
          })
        }
      }

      return inconsistencias
    },

    atualizarProfissionais(profissionaisAtualizados) {
      this.formData.fichaAtividadeColetivaTransport.profissionais = [
        ...profissionaisAtualizados,
      ]
      // UI (TabCabecalho): "N° de participantes" aqui representa a quantidade de PROFISSIONAIS adicionados
      // FAC (1ª chamada): dados.numParticipantes continua sendo de participantes/cidadãos (hoje: 0)
      const totalProfissionais =
        this.formData.fichaAtividadeColetivaTransport.profissionais.length
      this.formData.fichaAtividadeColetivaTransport.numeroParticipantes =
        totalProfissionais
      if (this.$refs.cabecalho) {
        this.$refs.cabecalho.formData.numeroParticipantes = totalProfissionais
      }

      // Limpa o erro de responsável se houver um responsável marcado
      const temResponsavel = profissionaisAtualizados.some(
        (prof) => prof.logado === true || prof.isResponsavel === true
      )
      if (temResponsavel) {
        this.erroResponsavel = null
      }

      this.definirTipoAtividadePorProfissionais()
    },
    definirTipoAtividadePorProfissionais() {
      const lista =
        this.formData.fichaAtividadeColetivaTransport.profissionais || []
      if (!Array.isArray(lista) || lista.length === 0) {
        return
      }

      // Coleta INE de cada profissional (pode vir como nu_ine ou ine)
      const ines = lista.map((p) => p.nu_ine || p.ine || null)

      const temSemIne = ines.some((ine) => !ine)
      const inesValidos = ines.filter((ine) => !!ine)
      const distintos = Array.from(new Set(inesValidos))

      let idTipo = null

      if (temSemIne) {
        // Existe pelo menos um profissional sem INE → Reunião intersetorial / ...
        idTipo = '03'
      } else if (distintos.length === 1) {
        // Todos com o mesmo INE → Reunião de equipe
        idTipo = '01'
      } else if (distintos.length > 1) {
        // INEs diferentes → Reunião com outras equipes de saúde
        idTipo = '02'
      }

      if (idTipo) {
        const tipoObj =
          this.opcoesTipoAtividade.find((opt) => opt.id === idTipo) || null
        if (tipoObj) {
          this.formData.fichaAtividadeColetivaTransport.atividadeTipo = tipoObj
          this.erros.tipoAtividade = null
        }
      }
    },
    async carregarCidadaos() {
      if (this.cidadaosDisponiveis.length > 0) {
        return Promise.resolve() // Já carregado
      }

      this.isLoadingCidadaos = true
      try {
        // Busca participantes/cidadãos usando o endpoint de atividade coletiva
        // Obtém cod_ibge e nu_ine do token decodificado
        let codIbge = this.$store.state.cod_ibge
        let nuIne = this.$store.state.nu_ine

        // Decodifica o token para pegar os valores corretos
        if (this.$store.state.accessToken) {
          const decoded = jwtDecode(this.$store.state.accessToken)
          codIbge = decoded.cod_ibge || codIbge
          nuIne = decoded.nu_ine || nuIne
        }

        // Fallback para valores padrão se ainda não tiver
        codIbge = codIbge || '2512606'
        nuIne = nuIne || '0000130532'

        const response = await this.$api.get(
          `/app/atividade-coletiva/${codIbge}/${nuIne}/participantes`
        )

        // Processa os dados retornados pela API de participantes
        const dados = Array.isArray(response.data) ? response.data : []

        this.cidadaosDisponiveis = dados.map((cid) => {
          // Campos retornados pela API de participantes
          const nome = cid.no_cidadao || cid.nome || 'Cidadão'
          const cpf = cid.nu_cpf || cid.cpf || ''
          const cns = cid.nu_cns || cid.cns || ''
          const dataNasc = cid.dt_nascimento || cid.data_nascimento || ''
          const nomeMae = cid.no_nome_mae || cid.nome_mae || ''

          // Formata CPF se necessário
          const cpfFormatado = cpf ? this.formatarCPF(cpf) : ''
          // Formata CNS se necessário
          const cnsFormatado = cns && cns !== '-' ? this.formatarCNS(cns) : '-'
          // Formata data se necessário
          const dataFormatada = dataNasc ? this.formatarData(dataNasc) : ''

          const label = `${nome}${
            cpfFormatado ? ' - CPF: ' + cpfFormatado : ''
          }${
            cnsFormatado && cnsFormatado !== '-'
              ? ' - CNS: ' + cnsFormatado
              : ''
          }${dataFormatada ? ' - Nascimento: ' + dataFormatada : ''}`

          return {
            nome: nome,
            cpf: cpfFormatado,
            cns: cnsFormatado,
            dataNascimento: dataFormatada,
            nomeMae: nomeMae,
            label: label,
            // Dados originais para busca
            searchText:
              `${nome} ${cpf} ${cns} ${dataNasc} ${nomeMae}`.toLowerCase(),
            // Dados para salvar (preserva estrutura original)
            dadosOriginais: cid,
          }
        })
      } catch (error) {
        // Dados mockados para teste quando há erro
        this.cidadaosDisponiveis = [
          {
            nome: 'Pedro Oliveira',
            cpf: '111.222.333-44',
            cns: '123 4567 8901 2345',
            dataNascimento: '15/03/1990',
            nomeMae: 'Ana Oliveira',
            label:
              'Pedro Oliveira - CPF: 111.222.333-44 - CNS: 123 4567 8901 2345 - Nascimento: 15/03/1990',
            searchText:
              'pedro oliveira 11122233344 123456789012345 15/03/1990 ana oliveira'.toLowerCase(),
            dadosOriginais: {
              id: 1,
              no_cidadao: 'Pedro Oliveira',
              nu_cpf: '11122233344',
              nu_cns: '123456789012345',
              dt_nascimento: '1990-03-15',
              no_nome_mae: 'Ana Oliveira',
              sexo: 'M',
              peso: 75.5,
              altura: 175.0,
            },
          },
          {
            nome: 'Ana Costa',
            cpf: '555.666.777-88',
            cns: '987 6543 2109 8765',
            dataNascimento: '22/07/1985',
            nomeMae: 'Maria Costa',
            label:
              'Ana Costa - CPF: 555.666.777-88 - CNS: 987 6543 2109 8765 - Nascimento: 22/07/1985',
            searchText:
              'ana costa 55566677788 987654321098765 22/07/1985 maria costa'.toLowerCase(),
            dadosOriginais: {
              id: 2,
              no_cidadao: 'Ana Costa',
              nu_cpf: '55566677788',
              nu_cns: '987654321098765',
              dt_nascimento: '1985-07-22',
              no_nome_mae: 'Maria Costa',
              sexo: 'F',
              peso: 62.3,
              altura: 162.5,
            },
          },
        ]
        this.$toast.warning('Usando dados de teste (mockados)', 'Aviso', {
          position: 'topRight',
          timeout: 3000,
        })
      } finally {
        this.isLoadingCidadaos = false
      }

      // Se não retornou nenhum cidadão, usa dados mockados
      if (this.cidadaosDisponiveis.length === 0) {
        this.cidadaosDisponiveis = [
          {
            nome: 'Pedro Oliveira',
            cpf: '111.222.333-44',
            cns: '123 4567 8901 2345',
            dataNascimento: '15/03/1990',
            nomeMae: 'Ana Oliveira',
            label:
              'Pedro Oliveira - CPF: 111.222.333-44 - CNS: 123 4567 8901 2345 - Nascimento: 15/03/1990',
            searchText:
              'pedro oliveira 11122233344 123456789012345 15/03/1990 ana oliveira'.toLowerCase(),
            dadosOriginais: {
              id: 1,
              no_cidadao: 'Pedro Oliveira',
              nu_cpf: '11122233344',
              nu_cns: '123456789012345',
              dt_nascimento: '1990-03-15',
              no_nome_mae: 'Ana Oliveira',
              sexo: 'M',
              peso: 75.5,
              altura: 175.0,
            },
          },
          {
            nome: 'Ana Costa',
            cpf: '555.666.777-88',
            cns: '987 6543 2109 8765',
            dataNascimento: '22/07/1985',
            nomeMae: 'Maria Costa',
            label:
              'Ana Costa - CPF: 555.666.777-88 - CNS: 987 6543 2109 8765 - Nascimento: 22/07/1985',
            searchText:
              'ana costa 55566677788 987654321098765 22/07/1985 maria costa'.toLowerCase(),
            dadosOriginais: {
              id: 2,
              no_cidadao: 'Ana Costa',
              nu_cpf: '55566677788',
              nu_cns: '987654321098765',
              dt_nascimento: '1985-07-22',
              no_nome_mae: 'Maria Costa',
              sexo: 'F',
              peso: 62.3,
              altura: 162.5,
            },
          },
        ]
      }
    },
    filtrarCidadaos(options, search) {
      if (!search) {
        return options
      }
      const searchLower = search.toLowerCase().replace(/\D/g, '') // Remove caracteres não numéricos para busca
      return options.filter((cid) => {
        // Busca no texto de busca pré-processado
        if (cid.searchText && cid.searchText.includes(search.toLowerCase())) {
          return true
        }
        // Busca também removendo formatação para CPF/CNS
        const nome = (cid.nome || '').toLowerCase()
        const cns = (cid.cns || '').replace(/\D/g, '')
        const cpf = (cid.cpf || '').replace(/\D/g, '')
        const searchClean = search.replace(/\D/g, '')

        return (
          nome.includes(search.toLowerCase()) ||
          (searchClean && cns.includes(searchClean)) ||
          (searchClean && cpf.includes(searchClean))
        )
      })
    },
    formatarCPF(cpf) {
      if (!cpf) return ''
      const digits = cpf.replace(/\D/g, '')
      if (digits.length !== 11) return cpf
      return `${digits.substr(0, 3)}.${digits.substr(3, 3)}.${digits.substr(
        6,
        3
      )}-${digits.substr(9, 2)}`
    },
    formatarCNS(cns) {
      if (!cns || cns === '-') return '-'
      const digits = cns.replace(/\D/g, '')
      if (digits.length !== 15) return cns
      return `${digits.substr(0, 3)} ${digits.substr(3, 4)} ${digits.substr(
        7,
        4
      )} ${digits.substr(11, 4)}`
    },
    formatarData(data) {
      if (!data) return ''
      if (data.includes('/')) return data
      if (data.includes('-')) {
        const partes = data.split('-')
        if (partes.length === 3) {
          return `${partes[2]}/${partes[1]}/${partes[0]}`
        }
      }
      return data
    },
    abrirModalParticipante() {
      this.$refs.modalParticipante.show()
    },
    fecharModalParticipante() {
      this.$refs.modalParticipante.hide()
      this.resetarModalParticipante()
    },
    resetarModalParticipante() {
      this.novoParticipante = {
        cidadao: null,
        avaliacaoAlterada: false,
      }
    },
    adicionarParticipante() {
      if (!this.novoParticipante.cidadao) {
        return
      }

      const cidadao = this.novoParticipante.cidadao
      const dadosOriginais = cidadao.dadosOriginais || {}

      // Remove formatação para comparação
      const cpfLimpoParaComparacao = dadosOriginais.nu_cpf
        ? String(dadosOriginais.nu_cpf).replace(/\D/g, '')
        : null
      const cnsLimpoParaComparacao = dadosOriginais.nu_cns
        ? String(dadosOriginais.nu_cns).replace(/\D/g, '')
        : null

      // Verifica se o participante já foi adicionado (compara CPF e CNS limpos)
      const jaExiste =
        this.formData.fichaAtividadeColetivaTransport.participantes.some(
          (p) => {
            const pCpf = p.cpfParticipante
              ? String(p.cpfParticipante).replace(/\D/g, '')
              : null
            const pCns = p.cnsParticipante
              ? String(p.cnsParticipante).replace(/\D/g, '')
              : null

            return (
              (cpfLimpoParaComparacao &&
                pCpf &&
                pCpf === cpfLimpoParaComparacao) ||
              (cnsLimpoParaComparacao &&
                pCns &&
                pCns === cnsLimpoParaComparacao)
            )
          }
        )

      if (jaExiste) {
        this.$toast.warning(
          'Este cidadão já foi adicionado como participante',
          'Aviso',
          {
            position: 'topRight',
            timeout: 3000,
          }
        )
        return
      }

      // Converte data de nascimento para timestamp (epoch em ms)
      let dataNascimentoTimestamp = null
      if (dadosOriginais.dt_nascimento) {
        const dataNasc = new Date(dadosOriginais.dt_nascimento)
        if (!isNaN(dataNasc.getTime())) {
          dataNascimentoTimestamp = dataNasc.getTime()
        }
      }

      // Determina sexo (M = 0, F = 1)
      let sexo = null
      if (dadosOriginais.sexo) {
        sexo =
          dadosOriginais.sexo === 'M'
            ? 0
            : dadosOriginais.sexo === 'F'
            ? 1
            : null
      }

      // Peso e altura vêm dos dados originais do cidadão (se disponíveis)
      const peso = dadosOriginais.peso || null
      const altura = dadosOriginais.altura || null

      // Remove formatação de CPF e CNS (apenas números)
      const cpfLimpo = dadosOriginais.nu_cpf
        ? dadosOriginais.nu_cpf.replace(/\D/g, '')
        : null
      const cnsLimpo = dadosOriginais.nu_cns
        ? dadosOriginais.nu_cns.replace(/\D/g, '')
        : null

      const participante = {
        nome: cidadao.nome, // Campo interno para exibição
        cpfParticipante: cpfLimpo || null, // Apenas números
        cnsParticipante: cnsLimpo || null, // Apenas números
        dataNascimento: dataNascimentoTimestamp,
        sexo: sexo,
        peso: peso, // Vem dos dados do cidadão
        altura: altura, // Vem dos dados do cidadão
        avaliacaoAlterada: this.novoParticipante.avaliacaoAlterada || false,
      }

      this.formData.fichaAtividadeColetivaTransport.participantes.push(
        participante
      )

      this.validarParticipantes()
      this.fecharModalParticipante()
    },
    removerParticipante(index) {
      this.formData.fichaAtividadeColetivaTransport.participantes.splice(
        index,
        1
      )
      this.validarParticipantes()
    },
    formatarDataParticipante(timestamp) {
      if (!timestamp) return '-'
      const data = new Date(timestamp)
      if (isNaN(data.getTime())) return '-'
      return data.toLocaleDateString('pt-BR')
    },
    gerarUuidDadoSerializado(cnes) {
      const uuid = uuidv4()
      return uuid
    },
    getCboId(cbo) {
      const funcaoReverseMap = {
        'Administrador e-SUS PEC': '2',
        'Agente Comunitário de Saúde': '3',
        'Enfermeiro(a)': '4',
        'Aux/Téc Enfermagem': '6',
        'Odontólogo(a)': '8',
        Recepcionista: '5',
      }
      return funcaoReverseMap[cbo] || '2'
    },

    validarTipo() {
      if (!this.formData.fichaAtividadeColetivaTransport.atividadeTipo) {
        this.erros.tipoAtividade = 'O tipo da atividade é obrigatório.'
      } else {
        this.erros.tipoAtividade = null
        // Quando o tipo muda, revalida campos condicionais
        this.validarTemaReuniao()
        this.validarTemasParaSaude()
      }
    },
    onTipoMudou(tipoSelecionado) {
      // Sempre que o usuário mudar o "Tipo" (catálogo de oficina),
      // atualiza automaticamente o "Tema da reunião":
      // - se id != 5: seleciona 3, 4, 6, 7
      // - se id == 5 (Atividade Coletiva): limpa
      if (!tipoSelecionado) {
        this.formData.fichaAtividadeColetivaTransport.temasParaReuniao = []
        this.validarTemaReuniao()
        return
      }

      const tipoIdRaw =
        typeof tipoSelecionado === 'object' && tipoSelecionado !== null
          ? tipoSelecionado.id ?? tipoSelecionado.codigo
          : tipoSelecionado

      const tipoId =
        tipoIdRaw !== null && tipoIdRaw !== undefined ? Number(tipoIdRaw) : null

      if (tipoId === 5) {
        this.formData.fichaAtividadeColetivaTransport.temasParaReuniao = []
        this.validarTemaReuniao()
        return
      }

      if (tipoId) {
        const temasParaPreSelecionar = [3, 4, 6, 7]
        const temasObjetos = temasParaPreSelecionar
          .map((id) => this.opcoesTemasReuniao.find((opt) => opt.id === id))
          .filter(Boolean)

        this.formData.fichaAtividadeColetivaTransport.temasParaReuniao =
          temasObjetos
        this.validarTemaReuniao()
      }
    },
    isTemaReuniaoSelecionado(option) {
      if (
        !option ||
        !this.formData.fichaAtividadeColetivaTransport.temasParaReuniao
      ) {
        return false
      }
      const selecionados =
        this.formData.fichaAtividadeColetivaTransport.temasParaReuniao
      if (!Array.isArray(selecionados) || selecionados.length === 0) {
        return false
      }
      const optionId = option.id || option
      return selecionados.some((selecionado) => {
        const selecionadoId =
          selecionado && typeof selecionado === 'object'
            ? selecionado.id
            : selecionado
        return String(selecionadoId) === String(optionId)
      })
    },
    validarTemaReuniao() {
      if (this.isTemaReuniaoObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.temasParaReuniao ||
          this.formData.fichaAtividadeColetivaTransport.temasParaReuniao
            .length === 0
        ) {
          this.erros.temaReuniao =
            'O tema da reunião é obrigatório para este tipo de atividade.'
        } else {
          this.erros.temaReuniao = null
        }
      } else {
        this.erros.temaReuniao = null
      }
    },
    validarTemasParaSaude() {
      if (this.isTemasParaSaudeObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.temasParaSaude ||
          this.formData.fichaAtividadeColetivaTransport.temasParaSaude
            .length === 0
        ) {
          this.erros.temasParaSaude =
            'Os temas para a saúde são obrigatórios para este tipo de atividade.'
        } else {
          this.erros.temasParaSaude = null
        }
      } else {
        this.erros.temasParaSaude = null
      }
    },
    validarPublicoAlvo() {
      if (this.isPublicoAlvoObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.publicoAlvo ||
          this.formData.fichaAtividadeColetivaTransport.publicoAlvo.length === 0
        ) {
          this.erros.publicoAlvo =
            'O público-alvo é obrigatório para este tipo de atividade.'
        } else {
          this.erros.publicoAlvo = null
        }
      } else {
        this.erros.publicoAlvo = null
      }
    },
    validarPraticasEmSaude() {
      if (this.isPraticasEmSaudeObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.praticasEmSaude ||
          this.formData.fichaAtividadeColetivaTransport.praticasEmSaude
            .length === 0
        ) {
          this.erros.praticasEmSaude =
            'As práticas em saúde são obrigatórias para este tipo de atividade.'
        } else {
          this.erros.praticasEmSaude = null
        }
      } else {
        this.erros.praticasEmSaude = null
      }
    },
    validarParticipantes() {
      if (this.isParticipantesObrigatorio) {
        if (
          !this.formData.fichaAtividadeColetivaTransport.participantes ||
          this.formData.fichaAtividadeColetivaTransport.participantes.length ===
            0
        ) {
          this.erros.participantes =
            'É necessário adicionar pelo menos um participante para este tipo de atividade.'
        } else {
          this.erros.participantes = null
        }
      } else {
        this.erros.participantes = null
      }
    },
    cancelar() {
      // Reseta o estado de envio
      this.envioSucesso = false
      this.jsonFinalEnviado = null
      // Volta para a página anterior ou limpa o formulário
      if (
        confirm(
          'Deseja realmente cancelar? Todas as alterações serão perdidas.'
        )
      ) {
        this.$router.go(-1)
      }
    },

    async salvar() {
      // Reseta o estado de envio sucesso para permitir salvar novamente
      this.envioSucesso = false

      // Ativa a exibição de erros em todos os componentes
      if (this.$refs.cabecalho) {
        this.$refs.cabecalho.mostrarErros = true
        this.$refs.cabecalho.validar()
      }

      // Valida campos de dados da atividade
      this.validarTipo()
      this.validarTemaReuniao()
      this.validarTemasParaSaude()
      this.validarPublicoAlvo()
      this.validarPraticasEmSaude()
      this.validarParticipantes()

      // Valida se há um responsável selecionado
      const profissionais =
        this.formData.fichaAtividadeColetivaTransport.profissionais || []
      const temResponsavel = profissionais.some(
        (prof) => prof.logado === true || prof.isResponsavel === true
      )

      if (profissionais.length > 0 && !temResponsavel) {
        this.erroResponsavel =
          'É necessário marcar um profissional como responsável.'
        this.$toast.error(
          'É necessário marcar um profissional como responsável antes de salvar.',
          'Atenção!',
          {
            position: 'topRight',
            timeout: 5000,
          }
        )
        return
      } else {
        this.erroResponsavel = null
      }

      // Recalcula inconsistências após ativar erros
      this.inconsistencias = this.gerarInconsistencias()

      // Valida antes de enviar
      if (this.inconsistencias.length > 0) {
        const listaCampos = this.inconsistencias
          .map((i) => `${i.campo} (${i.tab})`)
          .join(', ')
        this.$toast.error(
          `Corrija os seguintes campos: ${listaCampos}`,
          'Erro de Validação',
          {
            position: 'topRight',
            timeout: 8000,
          }
        )
        return
      }

      const extrairId = (item) => {
        if (!item) return null
        if (typeof item === 'object' && item.id !== undefined) {
          return typeof item.id === 'string' ? parseInt(item.id) : item.id
        }
        return typeof item === 'string' ? parseInt(item) : item
      }

      const dataAtividade =
        this.$refs.cabecalho?.formData?.data ||
        this.formData.fichaAtividadeColetivaTransport.data

      const profissionaisFormatados = (
        this.formData.fichaAtividadeColetivaTransport.profissionais || []
      )
        .map((prof) => {
          const cns = prof.cnsProfissional || prof.nu_cns || prof.cns || null
          let nu_cpf = prof.nu_cpf || prof.cpf || ''
          nu_cpf = nu_cpf ? String(nu_cpf).replace(/\D/g, '') : null
          const no_profissional = prof.no_profissional || prof.nome || null

          return {
            cnsProfissional: cns || null,
            codigoCbo2002: prof.id_funcao || prof.co_cbo || null,
            nu_cpf: nu_cpf || null,
            no_profissional: no_profissional || null,
          }
        })
        .filter(
          (prof) =>
            prof.cnsProfissional ||
            prof.codigoCbo2002 ||
            prof.nu_cpf ||
            prof.no_profissional
        )

      const idAtividade = this.$route.query.id || null
      const isEdicao = !!idAtividade

      // Na criação, se não houver responsável, marca o primeiro profissional como responsável
      if (
        !isEdicao &&
        this.formData.fichaAtividadeColetivaTransport.profissionais.length > 0
      ) {
        const temResponsavel =
          this.formData.fichaAtividadeColetivaTransport.profissionais.some(
            (prof) => prof.logado === true || prof.isResponsavel === true
          )

        if (!temResponsavel) {
          // Marca o primeiro profissional como responsável
          this.formData.fichaAtividadeColetivaTransport.profissionais[0].logado = true
          this.formData.fichaAtividadeColetivaTransport.profissionais[0].isResponsavel = true
        }
      }

      let profissionalCNS = ''
      let cboCodigo_2002 = ''
      let cnes = this.formData.fichaAtividadeColetivaTransport.cnes || ''
      let ine = this.formData.fichaAtividadeColetivaTransport.inep || ''
      let codigoIbgeMunicipio =
        this.formData.codIbge || this.$store.state.cod_ibge || ''

      // Em EDIÇÃO, não usar dados do usuário logado/token para montar a ficha.
      // Prioriza sempre o profissional responsável (primeiro da lista) e os campos do formulário.
      const responsavelHeader =
        this.formData.fichaAtividadeColetivaTransport.profissionais &&
        this.formData.fichaAtividadeColetivaTransport.profissionais.length > 0
          ? this.formData.fichaAtividadeColetivaTransport.profissionais[0]
          : null

      if (responsavelHeader) {
        profissionalCNS =
          responsavelHeader.cnsProfissional ||
          responsavelHeader.nu_cns ||
          responsavelHeader.cns ||
          ''
        cboCodigo_2002 =
          responsavelHeader.id_funcao || responsavelHeader.co_cbo || ''
        cnes =
          this.formData.fichaAtividadeColetivaTransport.cnes ||
          responsavelHeader.nu_cnes ||
          cnes ||
          ''
        ine =
          this.formData.fichaAtividadeColetivaTransport.inep ||
          responsavelHeader.nu_ine ||
          ine ||
          ''
      }

      // Apenas quando NÃO for edição e ainda faltar dados, usa token/store como fallback.
      if (
        !isEdicao &&
        this.$store.state.accessToken &&
        (!profissionalCNS || !cboCodigo_2002)
      ) {
        try {
          const decoded = jwtDecode(this.$store.state.accessToken)
          profissionalCNS =
            profissionalCNS || decoded.nu_cns || this.$store.state.nu_cns || ''
          cboCodigo_2002 =
            cboCodigo_2002 || decoded.co_cbo || this.$store.state.co_cbo || ''
          cnes = cnes || decoded.nu_cnes || this.$store.state.nu_cnes || ''
          ine = ine || decoded.nu_ine || this.$store.state.nu_ine || ''
          codigoIbgeMunicipio =
            codigoIbgeMunicipio ||
            decoded.cod_ibge ||
            this.$store.state.cod_ibge ||
            ''
        } catch (e) {
          // mantém os valores atuais
        }
      }

      let dataAtendimentoTimestamp = new Date().getTime()
      if (dataAtividade) {
        const dataStr =
          typeof dataAtividade === 'string' ? dataAtividade.split('T')[0] : null
        const horaInicio =
          this.formData.fichaAtividadeColetivaTransport.horaInicio ||
          this.$refs.cabecalho?.formData?.horaInicio ||
          '00:00'
        const horaStr =
          String(horaInicio).length === 5 ? horaInicio + ':00' : horaInicio // "10:00" -> "10:00:00"
        const dataHoraStr = dataStr ? `${dataStr}T${horaStr}` : null
        const dataObj = dataHoraStr
          ? new Date(dataHoraStr)
          : dataAtividade instanceof Date
          ? dataAtividade
          : new Date(dataAtividade)
        if (!isNaN(dataObj.getTime())) {
          dataAtendimentoTimestamp = dataObj.getTime()
        }
      }

      const headerTransport = {
        profissionalCNS: profissionalCNS,
        cboCodigo_2002: cboCodigo_2002,
        cnes: cnes,
        ine: ine,
        dataAtendimento: dataAtendimentoTimestamp,
        codigoIbgeMunicipio: codigoIbgeMunicipio,
      }

      // Obtém o tipo de atividade para determinar campos condicionais
      const atividadeTipoId = extrairId(
        this.formData.fichaAtividadeColetivaTransport.atividadeTipo
      )
      const isTipoReuniao = ['01', '02', '03', 1, 2, 3].includes(
        atividadeTipoId
      )

      // NumParticipantes: prioriza o valor do input "N° de participantes", senão profissionais, senão participantes (cidadãos)
      // Em Oficinas/Treinamentos, o usuário adiciona profissionais e o input mostra a quantidade
      const numParticipantesInput =
        this.formData.fichaAtividadeColetivaTransport.numeroParticipantes
      const numProfissionais = (
        this.formData.fichaAtividadeColetivaTransport.profissionais || []
      ).length
      const numParticipantesCidadaos = (
        this.formData.fichaAtividadeColetivaTransport.participantes || []
      ).length
      const numParticipantesParaFAC =
        numParticipantesInput != null &&
        numParticipantesInput !== '' &&
        Number(numParticipantesInput) > 0
          ? Number(numParticipantesInput)
          : Math.max(numProfissionais, numParticipantesCidadaos, 0)

      // Campos obrigatórios sempre
      const dadosFormatados = {
        uuidFicha: `${cnes}-${this.formData.uuidDadoSerializado}`,
        numParticipantes: numParticipantesParaFAC,
        atividadeTipo: atividadeTipoId,
        turno: this.formData.fichaAtividadeColetivaTransport.turno
          ? parseInt(this.formData.fichaAtividadeColetivaTransport.turno)
          : null,
        tbCdsOrigem: 3,
        pseEducacao:
          this.formData.fichaAtividadeColetivaTransport.programaEducacao ||
          false,
        pseSaude:
          this.formData.fichaAtividadeColetivaTransport.programaSaude || false,
        headerTransport: headerTransport,
      }

      // Campos condicionais para tipos 01, 02, 03 (temasParaReuniao é obrigatório)
      if (isTipoReuniao) {
        const temasParaReuniao = Array.isArray(
          this.formData.fichaAtividadeColetivaTransport.temasParaReuniao
        )
          ? this.formData.fichaAtividadeColetivaTransport.temasParaReuniao
              .map(extrairId)
              .filter((id) => id !== null)
          : []
        if (temasParaReuniao.length > 0) {
          dadosFormatados.temasParaReuniao = temasParaReuniao
        }
      }

      // Campos opcionais (apenas se preenchidos)
      // Local da atividade (mutuamente exclusivos)
      if (this.formData.fichaAtividadeColetivaTransport.cnes) {
        dadosFormatados.cnesLocalAtividade =
          this.formData.fichaAtividadeColetivaTransport.cnes
      } else if (this.formData.fichaAtividadeColetivaTransport.inep) {
        dadosFormatados.inep =
          this.formData.fichaAtividadeColetivaTransport.inep
      } else if (
        this.formData.fichaAtividadeColetivaTransport.outraLocalidade
      ) {
        dadosFormatados.outraLocalidade =
          this.formData.fichaAtividadeColetivaTransport.outraLocalidade
      }

      // INEP obrigatório se PSE Educação ou Saúde
      if (
        (this.formData.fichaAtividadeColetivaTransport.programaEducacao ||
          this.formData.fichaAtividadeColetivaTransport.programaSaude) &&
        this.formData.fichaAtividadeColetivaTransport.inep
      ) {
        dadosFormatados.inep =
          this.formData.fichaAtividadeColetivaTransport.inep
      }

      // Profissionais (opcional)
      if (profissionaisFormatados.length > 0) {
        dadosFormatados.profissionais = profissionaisFormatados
      }

      // Obtém o IBGE do usuário logado
      const ibge = codigoIbgeMunicipio || this.$store.state.cod_ibge || ''

      const jsonFinal = {
        // Em edição, o uuid vem da rota (idAtividade) - usado para atualizar a FAC
        nu_uuid_ficha: String(
          this.formData.uuidDadoSerializado || idAtividade || ''
        ),
        dados: JSON.stringify(dadosFormatados),
        tp_ficha: '6', // tb_dim_tipo_ficha = 6 (CDS Ficha de Atividade Coletiva)
        ibge: String(ibge),
      }

      this.jsonFinalEnviado = jsonFinal

      try {
        this.enviando = true

        // ================================
        // 1) FAC (cria OU atualiza)
        // ================================
        let uuidFichaParaUsar = String(jsonFinal.nu_uuid_ficha || '')

        const responseFicha = await this.$api.post(
          '/app/oficinas-treinamentos/fichas-atividade-coletiva',
          jsonFinal
        )

        // Se for NOVA ficha, a API pode retornar o UUID gerado; mantém tudo consistente
        if (!idAtividade) {
          const uuidRetornado =
            (responseFicha &&
              responseFicha.data &&
              (responseFicha.data.uuidFicha ||
                responseFicha.data.nu_uuid_ficha)) ||
            (responseFicha &&
              responseFicha.data &&
              responseFicha.data.data &&
              responseFicha.data.data.uuidFicha) ||
            null

          if (uuidRetornado) {
            uuidFichaParaUsar = String(uuidRetornado)

            this.formData.uuidDadoSerializado = uuidFichaParaUsar
            dadosFormatados.uuidFicha = `${cnes}-${uuidFichaParaUsar}`
            jsonFinal.nu_uuid_ficha = uuidFichaParaUsar

            try {
              const dadosObj = JSON.parse(jsonFinal.dados)
              jsonFinal.dados = JSON.stringify({
                ...dadosObj,
                uuidFicha: `${cnes}-${uuidFichaParaUsar}`,
              })
            } catch (e) {}

            this.jsonFinalEnviado = jsonFinal
          }
        }

        // Salva a ficha no localStorage para aparecer na listagem (com UUID final)
        this.salvarFichaNoLocalStorage(jsonFinal)

        const responsavel =
          this.formData.fichaAtividadeColetivaTransport.profissionais &&
          this.formData.fichaAtividadeColetivaTransport.profissionais.length > 0
            ? this.formData.fichaAtividadeColetivaTransport.profissionais[0]
            : null

        let cpfFacilitador = ''
        let nomeFacilitador = ''
        if (responsavel) {
          cpfFacilitador =
            responsavel.nu_cpf || responsavel.cpf || cpfFacilitador || ''
          nomeFacilitador =
            responsavel.no_profissional ||
            responsavel.nome ||
            nomeFacilitador ||
            ''
        }
        // Apenas quando NÃO for edição e ainda faltar, usa token como fallback
        if (!cpfFacilitador && !isEdicao && this.$store.state.accessToken) {
          try {
            const decoded = jwtDecode(this.$store.state.accessToken)
            cpfFacilitador = decoded.nu_cpf || ''
            nomeFacilitador = nomeFacilitador || decoded.nome || ''
          } catch (e) {}
        }
        if (!cpfFacilitador) {
          cpfFacilitador = this.cpf || ''
        }

        const dataAtividade =
          this.$refs.cabecalho?.formData?.data ||
          this.formData.fichaAtividadeColetivaTransport.data
        const horaInicio =
          this.formData.fichaAtividadeColetivaTransport.horaInicio || '00:00'
        const horaFim =
          this.formData.fichaAtividadeColetivaTransport.horaFim || '00:00'

        const dataInicio = dataAtividade
          ? `${dataAtividade} ${horaInicio}:00`
          : null
        const dataFim = dataAtividade ? `${dataAtividade} ${horaFim}:00` : null

        // Carga horária agora é selecionada manualmente (1 a 8 horas)
        const qtdHoras =
          Number(this.formData.fichaAtividadeColetivaTransport.qtdHoras) || 0

        const formaMap = {
          presencial: 'Presencial',
          telepresenca: 'Telepresença',
          online: '100% Online',
        }
        const meio =
          formaMap[this.formData.fichaAtividadeColetivaTransport.forma] ||
          'Presencial'

        const ibge = this.formData.codIbge || this.$store.state.cod_ibge || ''

        let idTipo = null
        if (this.$refs.cabecalho && this.$refs.cabecalho.tipoSelecionado) {
          const tipoSelecionado = this.$refs.cabecalho.tipoSelecionado
          if (tipoSelecionado && tipoSelecionado.id) {
            idTipo =
              typeof tipoSelecionado.id === 'number'
                ? tipoSelecionado.id
                : parseInt(tipoSelecionado.id)
          }
        }

        if (!idTipo) {
          const tipoValue = this.formData.fichaAtividadeColetivaTransport.tipo
          if (tipoValue) {
            if (typeof tipoValue === 'object') {
              idTipo = tipoValue.id || tipoValue.codigo || null
            } else {
              idTipo =
                typeof tipoValue === 'number' ? tipoValue : parseInt(tipoValue)
            }
          }
        }

        // Formata data_atividade no formato YYYY-MM-DD (apenas a data, sem hora)
        const dataAtividadeFormatada = dataAtividade
          ? dataAtividade.split('T')[0]
          : null

        const payloadOficina = {
          // Para nova ficha, usamos o uuidFicha criado na FAC como id; em edição, mantém o id da rota
          id: idAtividade || uuidFichaParaUsar,
          id_catalogo_ofici_treinam: idTipo,
          cpf_facilitador: cpfFacilitador.replace(/\D/g, ''),
          nome_facilitador: nomeFacilitador,
          ibge: ibge,
          meio: meio,
          inicio: dataInicio,
          fim: dataFim,
          data_atividade:
            dataAtividadeFormatada ||
            (dataInicio ? dataInicio.split(' ')[0] : null),
          qtd_horas: qtdHoras,
          // Backend/listagem usa este campo; aqui representa quantidade de PROFISSIONAIS adicionados (mesmo do input do cabeçalho)
          numero_participantes:
            this.formData.fichaAtividadeColetivaTransport.numeroParticipantes ||
            0,
          status: 'Em andamento',
        }

        const responseOficina = await this.$api.post(
          '/app/oficinas-treinamentos/oficinas',
          payloadOficina
        )

        if (!responseOficina || !responseOficina.data) {
          throw new Error('Resposta inválida da API ao salvar oficina')
        }

        if (responseOficina.data.error === true) {
          throw new Error(
            responseOficina.data.message || 'Erro ao salvar oficina'
          )
        }

        if (!responseOficina.data.id) {
          throw new Error('Não foi possível obter o ID da oficina salva')
        }

        const idOficina = responseOficina.data.id

        const participantes = (
          this.formData.fichaAtividadeColetivaTransport.profissionais || []
        )
          .map((prof) => {
            let nu_cpf = prof.nu_cpf || prof.cpf || prof.cpfParticipante || ''
            nu_cpf = nu_cpf ? String(nu_cpf).replace(/\D/g, '') : ''
            const no_profissional = prof.no_profissional || prof.nome || ''

            return {
              nu_cpf: nu_cpf || null,
              no_profissional: no_profissional || null,
            }
          })
          .filter((prof) => prof.nu_cpf || prof.no_profissional)

        const payloadProfissionais = {
          id_oficina_treinamento: idOficina,
          participantes: participantes,
        }

        const responseProfissionais = await this.$api.post(
          '/app/oficinas-treinamentos/oficina/participantes',
          payloadProfissionais
        )

        if (
          responseOficina &&
          (responseOficina.status === 200 || responseOficina.status === 201) &&
          responseProfissionais &&
          (responseProfissionais.status === 200 ||
            responseProfissionais.status === 201)
        ) {
          // Se for uma nova oficina (não tinha idAtividade), atualiza a rota com o ID retornado
          // para que ao salvar novamente, ele edite em vez de criar uma nova
          if (!idAtividade && idOficina) {
            this.$router.replace({
              path: this.$route.path,
              query: { ...this.$route.query, id: idOficina },
            })
            // Atualiza o uuidDadoSerializado com o ID da oficina para manter consistência
            this.formData.uuidDadoSerializado = String(idOficina)
          }

          this.$toast.success('Oficina salva com sucesso!', 'Sucesso', {
            position: 'topRight',
            timeout: 5000,
          })
        }
      } catch (error) {
        let mensagemErro = 'Erro ao enviar o formulário. Tente novamente.'

        if (error.response && error.response.data) {
          if (error.response.data.message) {
            mensagemErro = error.response.data.message
          } else if (error.response.data.error) {
            mensagemErro = error.response.data.error
          }
        }

        this.$toast.error('Erro ao salvar: ' + mensagemErro, 'Erro', {
          position: 'topRight',
          timeout: 7000,
        })
      } finally {
        this.enviando = false
      }
    },
    salvarFichaNoLocalStorage(jsonFinal) {
      try {
        // Recupera fichas existentes do localStorage
        const fichasSalvas = localStorage.getItem('fichas_atividade_coletiva')
        let fichas = fichasSalvas ? JSON.parse(fichasSalvas) : []

        // Verifica se a ficha já existe (pelo UUID)
        const uuid = jsonFinal.nu_uuid_ficha
        const indexExistente = fichas.findIndex(
          (f) => (f.nu_uuid_ficha || f.uuidFicha) === uuid
        )

        // Se já existe, atualiza; senão, adiciona nova
        if (indexExistente >= 0) {
          fichas[indexExistente] = jsonFinal
        } else {
          fichas.push(jsonFinal)
        }

        // Salva de volta no localStorage
        localStorage.setItem(
          'fichas_atividade_coletiva',
          JSON.stringify(fichas)
        )
      } catch (error) {
        // Erro ao salvar ficha no localStorage
      }
    },
    baixarXML() {
      if (!this.jsonFinalEnviado) {
        this.$toast.error('Não há dados para gerar o XML', 'Erro', {
          position: 'topRight',
          timeout: 3000,
        })
        return
      }

      try {
        const xml = this.gerarXML(this.jsonFinalEnviado)
        const blob = new Blob([xml], { type: 'application/xml' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url

        // Nome do arquivo: FAC_CNES_UUID.xml
        const uuid = this.jsonFinalEnviado.nu_uuid_ficha || 'ficha'
        const nomeArquivo = `FAC_${uuid}.xml`

        link.download = nomeArquivo
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$toast.success('XML baixado com sucesso!', 'Sucesso', {
          position: 'topRight',
          timeout: 3000,
        })
      } catch (error) {
        this.$toast.error('Erro ao gerar o arquivo XML', 'Erro', {
          position: 'topRight',
          timeout: 3000,
        })
      }
    },
    gerarXML(json) {
      // Função auxiliar para escapar caracteres XML
      const escapeXml = (str) => {
        if (str === null || str === undefined) return ''
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&apos;')
      }

      // Função auxiliar para formatar valor
      const formatarValor = (valor) => {
        if (valor === null || valor === undefined) return ''
        if (typeof valor === 'boolean') return valor ? 'true' : 'false'
        return String(valor)
      }

      // Função auxiliar para criar elemento XML simples
      const criarElementoSimples = (nome, valor, nivel = 0, namespace = '') => {
        const indentacao = '\t'.repeat(nivel)
        const valorFormatado = formatarValor(valor)
        const prefixo = namespace ? `${namespace}:` : ''
        if (valorFormatado === '') {
          return `${indentacao}<${prefixo}${nome}></${prefixo}${nome}>\n`
        }
        return `${indentacao}<${prefixo}${nome}>${escapeXml(
          valorFormatado
        )}</${prefixo}${nome}>\n`
      }

      // Função auxiliar para criar elemento XML complexo (objeto ou array)
      const criarElemento = (nome, valor, nivel = 0, namespace = '') => {
        const indentacao = '\t'.repeat(nivel)
        const prefixo = namespace ? `${namespace}:` : ''

        if (valor === null || valor === undefined) {
          return `${indentacao}<${prefixo}${nome}></${prefixo}${nome}>\n`
        }

        // Array de objetos
        if (
          Array.isArray(valor) &&
          valor.length > 0 &&
          typeof valor[0] === 'object'
        ) {
          let xml = ''
          valor.forEach((item) => {
            xml += `${indentacao}<${prefixo}${nome}>\n`
            Object.keys(item).forEach((key) => {
              xml += criarElemento(key, item[key], nivel + 1, '')
            })
            xml += `${indentacao}</${prefixo}${nome}>\n`
          })
          return xml
        }

        // Array de valores simples
        if (Array.isArray(valor)) {
          if (valor.length === 0) {
            return ''
          }
          let xml = ''
          valor.forEach((item) => {
            xml += criarElementoSimples(nome, item, nivel, '')
          })
          return xml
        }

        // Objeto
        if (typeof valor === 'object' && valor !== null) {
          let xml = `${indentacao}<${prefixo}${nome}>\n`
          Object.keys(valor).forEach((key) => {
            xml += criarElemento(key, valor[key], nivel + 1, '')
          })
          xml += `${indentacao}</${prefixo}${nome}>\n`
          return xml
        }

        // Valor simples
        return criarElementoSimples(nome, valor, nivel, '')
      }

      // Parse dos dados se for string JSON
      let dadosObj = {}
      if (json.dados) {
        if (typeof json.dados === 'string') {
          try {
            dadosObj = JSON.parse(json.dados)
          } catch (e) {
            dadosObj = {}
          }
        } else {
          dadosObj = json.dados
        }
      }

      // Gera o XML no formato exato
      let xml = '<?xml version="1.0" encoding="UTF-8"?>\n'
      xml +=
        '<ns3:dadoTransporteTransportXml xmlns:ns2="http://esus.ufsc.br/dadoinstalacao" xmlns:ns3="http://esus.ufsc.br/dadotransporte" xmlns:ns4="http://esus.ufsc.br/fichaatividadecoletiva">\n'

      // Campos no nível raiz
      xml += criarElementoSimples(
        'uuidDadoSerializado',
        this.formData.uuidDadoSerializado || json.nu_uuid_ficha,
        1
      )
      xml += criarElementoSimples(
        'tipoDadoSerializado',
        this.formData.tipoDadoSerializado || json.tp_ficha || '3',
        1
      )
      xml += criarElementoSimples(
        'codIbge',
        this.formData.codIbge || json.ibge || this.$store.state.cod_ibge || '',
        1
      )
      xml += criarElementoSimples(
        'cnesDadoSerializado',
        this.formData.cnesDadoSerializado || '',
        1
      )
      xml += criarElementoSimples(
        'ineDadoSerializado',
        this.formData.ineDadoSerializado || '',
        1
      )
      xml += criarElementoSimples('numLote', this.formData.numLote || '4', 1)

      // ns4:fichaAtividadeColetivaTransport
      xml += '\t<ns4:fichaAtividadeColetivaTransport>\n'

      // Campos da ficha (apenas os que existem em dadosObj)
      if (dadosObj.uuidFicha)
        xml += criarElementoSimples('uuidFicha', dadosObj.uuidFicha, 2)
      if (dadosObj.inep) xml += criarElementoSimples('inep', dadosObj.inep, 2)
      if (dadosObj.numParticipantes !== undefined)
        xml += criarElementoSimples(
          'numParticipantes',
          dadosObj.numParticipantes,
          2
        )
      if (dadosObj.numAvaliacoesAlteradas !== undefined)
        xml += criarElementoSimples(
          'numAvaliacoesAlteradas',
          dadosObj.numAvaliacoesAlteradas,
          2
        )

      // Profissionais (array de objetos)
      if (dadosObj.profissionais && Array.isArray(dadosObj.profissionais)) {
        dadosObj.profissionais.forEach((prof) => {
          xml += '\t\t<profissionais>\n'
          if (prof.cnsProfissional)
            xml += criarElementoSimples(
              'cnsProfissional',
              prof.cnsProfissional,
              3
            )
          if (prof.codigoCbo2002)
            xml += criarElementoSimples('codigoCbo2002', prof.codigoCbo2002, 3)
          xml += '\t\t</profissionais>\n'
        })
      }

      if (dadosObj.atividadeTipo !== undefined)
        xml += criarElementoSimples('atividadeTipo', dadosObj.atividadeTipo, 2)

      // publicoAlvo (array de valores simples)
      if (dadosObj.publicoAlvo && Array.isArray(dadosObj.publicoAlvo)) {
        dadosObj.publicoAlvo.forEach((valor) => {
          xml += criarElementoSimples('publicoAlvo', valor, 2)
        })
      }

      // participantes (array de objetos)
      if (dadosObj.participantes && Array.isArray(dadosObj.participantes)) {
        dadosObj.participantes.forEach((participante) => {
          xml += '\t\t<participantes>\n'
          if (participante.cnsParticipante)
            xml += criarElementoSimples(
              'cnsParticipante',
              participante.cnsParticipante,
              3
            )
          if (participante.cpfParticipante)
            xml += criarElementoSimples(
              'cpfParticipante',
              participante.cpfParticipante,
              3
            )
          if (participante.dataNascimento)
            xml += criarElementoSimples(
              'dataNascimento',
              participante.dataNascimento,
              3
            )
          if (participante.avaliacaoAlterada !== undefined)
            xml += criarElementoSimples(
              'avaliacaoAlterada',
              participante.avaliacaoAlterada,
              3
            )
          if (participante.peso !== undefined && participante.peso !== null)
            xml += criarElementoSimples('peso', participante.peso, 3)
          if (participante.altura !== undefined && participante.altura !== null)
            xml += criarElementoSimples('altura', participante.altura, 3)
          if (participante.cessouHabitoFumar !== undefined)
            xml += criarElementoSimples(
              'cessouHabitoFumar',
              participante.cessouHabitoFumar,
              3
            )
          if (participante.abandonouGrupo !== undefined)
            xml += criarElementoSimples(
              'abandonouGrupo',
              participante.abandonouGrupo,
              3
            )
          if (participante.sexo !== undefined && participante.sexo !== null)
            xml += criarElementoSimples('sexo', participante.sexo, 3)
          xml += '\t\t</participantes>\n'
        })
      }

      if (dadosObj.tbCdsOrigem !== undefined)
        xml += criarElementoSimples('tbCdsOrigem', dadosObj.tbCdsOrigem, 2)
      if (dadosObj.procedimento)
        xml += criarElementoSimples('procedimento', dadosObj.procedimento, 2)
      if (dadosObj.turno !== undefined && dadosObj.turno !== null)
        xml += criarElementoSimples('turno', dadosObj.turno, 2)
      if (dadosObj.pseEducacao !== undefined)
        xml += criarElementoSimples('pseEducacao', dadosObj.pseEducacao, 2)
      if (dadosObj.pseSaude !== undefined)
        xml += criarElementoSimples('pseSaude', dadosObj.pseSaude, 2)

      // headerTransport
      if (dadosObj.headerTransport) {
        xml += '\t\t<headerTransport>\n'
        if (dadosObj.headerTransport.profissionalCNS)
          xml += criarElementoSimples(
            'profissionalCNS',
            dadosObj.headerTransport.profissionalCNS,
            3
          )
        if (dadosObj.headerTransport.cboCodigo_2002)
          xml += criarElementoSimples(
            'cboCodigo_2002',
            dadosObj.headerTransport.cboCodigo_2002,
            3
          )
        if (dadosObj.headerTransport.cnes)
          xml += criarElementoSimples('cnes', dadosObj.headerTransport.cnes, 3)
        if (dadosObj.headerTransport.ine)
          xml += criarElementoSimples('ine', dadosObj.headerTransport.ine, 3)
        if (dadosObj.headerTransport.dataAtendimento)
          xml += criarElementoSimples(
            'dataAtendimento',
            dadosObj.headerTransport.dataAtendimento,
            3
          )
        if (dadosObj.headerTransport.codigoIbgeMunicipio)
          xml += criarElementoSimples(
            'codigoIbgeMunicipio',
            dadosObj.headerTransport.codigoIbgeMunicipio,
            3
          )
        xml += '\t\t</headerTransport>\n'
      }

      // temasParaSaude (array de valores simples)
      if (dadosObj.temasParaSaude && Array.isArray(dadosObj.temasParaSaude)) {
        dadosObj.temasParaSaude.forEach((valor) => {
          xml += criarElementoSimples('temasParaSaude', valor, 2)
        })
      }

      // temasParaReuniao (array de valores simples)
      if (
        dadosObj.temasParaReuniao &&
        Array.isArray(dadosObj.temasParaReuniao)
      ) {
        dadosObj.temasParaReuniao.forEach((valor) => {
          xml += criarElementoSimples('temasParaReuniao', valor, 2)
        })
      }

      // praticasEmSaude (array de valores simples)
      if (dadosObj.praticasEmSaude && Array.isArray(dadosObj.praticasEmSaude)) {
        dadosObj.praticasEmSaude.forEach((valor) => {
          xml += criarElementoSimples('praticasEmSaude', valor, 2)
        })
      }

      // cnesLocalAtividade
      if (dadosObj.cnesLocalAtividade)
        xml += criarElementoSimples(
          'cnesLocalAtividade',
          dadosObj.cnesLocalAtividade,
          2
        )

      // outraLocalidade
      if (dadosObj.outraLocalidade)
        xml += criarElementoSimples(
          'outraLocalidade',
          dadosObj.outraLocalidade,
          2
        )

      xml += '\t</ns4:fichaAtividadeColetivaTransport>\n'

      // ns2:remetente
      xml += '\t<ns2:remetente>\n'
      xml += criarElementoSimples('contraChave', 'TREINAMENTO', 2)
      xml += criarElementoSimples('uuidInstalacao', 'TREINAMENTO', 2)
      xml += criarElementoSimples('cpfOuCnpj', '01234567890', 2)
      xml += criarElementoSimples(
        'nomeOuRazaoSocial',
        'ADMINISTRADOR INSTALAÇÃO',
        2
      )
      xml += criarElementoSimples('fone', '8216756527', 2)
      xml += criarElementoSimples('email', 'prof@esus.br', 2)
      xml += criarElementoSimples('versaoSistema', '5.0.16', 2)
      xml += criarElementoSimples('nomeBancoDados', 'Oracle', 2)
      xml += '\t</ns2:remetente>\n'

      // ns2:originadora
      xml += '\t<ns2:originadora>\n'
      xml += criarElementoSimples('contraChave', 'TREINAMENTO', 2)
      xml += criarElementoSimples('uuidInstalacao', 'TREINAMENTO', 2)
      xml += criarElementoSimples('cpfOuCnpj', '01234567890', 2)
      xml += criarElementoSimples(
        'nomeOuRazaoSocial',
        'ADMINISTRADOR INSTALAÇÃO',
        2
      )
      xml += criarElementoSimples('fone', '8216756527', 2)
      xml += criarElementoSimples('email', 'prof@esus.br', 2)
      xml += criarElementoSimples('versaoSistema', '5.0.16', 2)
      xml += criarElementoSimples('nomeBancoDados', 'Oracle', 2)
      xml += '\t</ns2:originadora>\n'

      // versao
      xml += '\t<versao major="4" minor="4" revision="1" />\n'

      xml += '</ns3:dadoTransporteTransportXml>'

      return xml
    },
  },
  watch: {
    // Quando o usuário altera o "Tipo" (catálogo de oficina) no TabCabecalho,
    // o TabCabecalho atualiza `formData.tipo` (via prop). Aqui, reagimos direto
    // nesse campo para garantir que o "Tema da reunião" seja atualizado sempre.
    'formData.fichaAtividadeColetivaTransport.tipo'(newTipo, oldTipo) {
      if (newTipo === oldTipo) return
      // newTipo é o id do catálogo (number)
      this.onTipoMudou(newTipo)
    },
    // Limpa campos condicionais quando o tipo de atividade muda
    'formData.fichaAtividadeColetivaTransport.atividadeTipo'(newTipo, oldTipo) {
      if (newTipo && oldTipo && newTipo.id !== oldTipo.id) {
        // Limpa temasParaReuniao se não for mais obrigatório
        if (!this.isTemaReuniaoObrigatorio) {
          this.formData.fichaAtividadeColetivaTransport.temasParaReuniao = []
        }
        // Limpa temasParaSaude se não for mais obrigatório
        if (!this.isTemasParaSaudeObrigatorio) {
          this.formData.fichaAtividadeColetivaTransport.temasParaSaude = []
        }
        // Limpa publicoAlvo se não for mais obrigatório
        if (!this.isPublicoAlvoObrigatorio) {
          this.formData.fichaAtividadeColetivaTransport.publicoAlvo = []
        }
        // Limpa praticasEmSaude se não for mais obrigatório
        if (!this.isPraticasEmSaudeObrigatorio) {
          this.formData.fichaAtividadeColetivaTransport.praticasEmSaude = []
          this.formData.fichaAtividadeColetivaTransport.procedimento = null
        }
        // Limpa participantes se não for mais obrigatório (mas mantém se já tiver dados)
        // Comentado para não perder dados quando o usuário muda o tipo
        // if (!this.isParticipantesObrigatorio && this.formData.fichaAtividadeColetivaTransport.participantes.length > 0) {
        //   this.formData.fichaAtividadeColetivaTransport.participantes = [];
        // }
      }
    },
    // Limpa procedimento se praticasEmSaude não contém mais o valor 30
    'formData.fichaAtividadeColetivaTransport.praticasEmSaude'(newVal) {
      if (
        !this.mostrarProcedimento &&
        this.formData.fichaAtividadeColetivaTransport.procedimento
      ) {
        this.formData.fichaAtividadeColetivaTransport.procedimento = null
      }
    },
  },
}
</script>

<style scoped>
.participantes-section {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.participantes-section h6 {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 8px;
}

.participantes-section .small {
  font-size: 0.875rem;
  color: #6c757d;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}

.table td {
  vertical-align: middle;
}

.btn-link.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 1rem;
}

.btn-link.btn-sm:hover {
  text-decoration: none;
}
</style>

<style scoped>
.card-topo {
  padding: 0px;
}

.gap-2 {
  gap: 0.5rem;
}

.mt-4 {
  margin-top: 1.5rem;
}
</style>
